<template>
    <fragment>
        <b-modal  v-model="modalVisible" :size="modalSize">
            <template v-slot:modal-header="{ close }">
                <div class="row" style="width: 100%">
                    <div class="col-md-10 offset-md-1 text-center d-flex justify-content-center">
                        <h3> {{ __('connect_with') }} </h3>
                        <button-open-help-modal :helpName="helpLocalizationName" :inExtraDiv="false" :color="'black'"/>
                    </div>
                    <div class="col-md-1">
                        <button type="button" class="close" v-on:click="restoreModal">
                            <span aria-hidden="true">&times;</span>
                            <span class="sr-only">{{ __('close') }}</span>
                        </button>
                    </div>
                </div>
            </template>

            <template v-slot:default="{}">
                <div class="row connect-with-content" id="modalContent">
                    <div class="col-md-12">
                        <div class="table-responsive text-nowrap">
                            <table class="table table-striped operation-modal-documents">
                                <thead v-if="modalType === 'localContractor'">
                                    <tr>
                                        <th class="th-first-modal-border-fix"></th>
                                        <th class="text-left width-fix">{{ __('document_or_group') }}</th>
                                        <th class="width-fix">{{ __('date_issued') }}</th>
                                        <th class="text-right width-fix">{{ __('document_amount') }}</th>
                                        <th class="text-right width-fix">{{ __('document_balance') }}</th>
                                        <th class="text-right width-fix">{{ __('balance_after_allocation') }}</th>
                                        <th class="width-fix">{{ __('currency') }}</th>
                                        <th class="text-right width-fix allocated-header">{{ __('allocated') }}</th>
                                        <th class="width-fix">{{ __('currency') }} ({{ __('payments') }})</th>
                                        <th class="text-right width-fix exchange-rate-header">
                                            {{ __('exchange_rate') }}
                                        </th>
                                        <th class="text-right width-fix">{{ __('calculated_amount') }}</th>
                                        <th class="th-before width-fix th-last">{{ __('currency') }}</th>
                                    </tr>
                                </thead>
                                <tbody v-show="modalType === 'localContractor'">
                                    <modal-document-line
                                        v-for="(document, index) in operationDocuments"
                                        :index="index"
                                        :has-error="rowHasError(index, 'documentAllocations')"
                                        :error-message="getErrorMessage(index, 'documentAllocations')"
                                        :colspan="colspan"
                                        :document="document"
                                        :operation="operation"
                                        :context="dynamicContent"
                                        :method="method"
                                        :modal-type="'localContractor'"
                                        :total-allocated="totalAllocated"
                                        :modalVisible="modalVisible"
                                        :disabled="disabled"
                                        :document-type="'operationDocument'"
                                        :key="index"
                                        @documentAllocationChanged="handleDocumentAllocationChanged"
                                        @totalAllocatedChanged="handleTotalAllocatedRequest"
                                        @dynamicChangeDocumentBalance="handleDynamicChangeDocumentBalance"
                                    >
                                    </modal-document-line>
                                    <tr class="row-one-line" v-if="operationDocuments.length === 0">
                                        <td class="td-padding"></td>
                                        <td class="text-left" colspan="5"> {{ __('no_documents') }}</td>
                                    </tr>
                                </tbody>
                                <!--  PROFORMA START                             -->
                                <thead v-if="modalType === 'localContractor' && operationProformas.length > 0 && operationAmountGtZero()">
                                <tr>
                                    <th class="th-first-modal-border-fix"></th>
                                    <th class="text-left width-fix">{{ __('document_or_group_proforma') }}</th>
                                    <th class="width-fix">{{ __('date_issued') }}</th>
                                    <th class="text-right width-fix">{{ __('document_amount') }}</th>
                                    <th class="text-right width-fix">{{ __('expected_amount') }}</th>
                                    <th class="text-right width-fix">{{ __('missing_payment') }}</th>
                                    <th class="width-fix">{{ __('currency') }}</th>
                                    <th class="text-right width-fix allocated-header">{{ __('allocated') }}</th>
                                    <th class="width-fix">{{ __('currency') }} ({{ __('payments') }})</th>
                                    <th class="text-right width-fix exchange-rate-header">
                                    </th>
                                    <th class="text-right width-fix"></th>
                                    <th class="th-before width-fix th-last"></th>
                                </tr>
                                </thead>
                                <tbody v-show="modalType === 'localContractor' && operationProformas.length > 0 && operationAmountGtZero()">
                                <modal-document-line
                                    v-for="(document, index) in operationProformas"
                                    :index="index"
                                    :has-error="rowHasError(index, 'documentAllocations')"
                                    :error-message="getErrorMessage(index, 'documentAllocations')"
                                    :colspan="colspan"
                                    :document="document"
                                    :operation="operation"
                                    :context="dynamicContent"
                                    :method="method"
                                    :modal-type="'localContractor'"
                                    :total-allocated="totalAllocated"
                                    :modalVisible="modalVisible"
                                    :disabled="disabled"
                                    :document-type="'operationDocument'"
                                    :key="index"
                                    @documentAllocationChanged="handleDocumentProformaAllocationChanged"
                                    @totalAllocatedChanged="handleTotalAllocatedProformaRequest"
                                    @dynamicChangeDocumentBalance="handleDynamicChangeDocumentBalance"
                                >
                                </modal-document-line>
                                <tr class="row-one-line" v-if="operationProformas.length === 0">
                                    <td class="td-padding"></td>
                                    <td class="text-left" colspan="5"> {{ __('no_documents') }}</td>
                                </tr>
                                </tbody>
                                <!--     PROFORMA END                           -->
                                <thead v-if="modalType !== 'noContractor'">
                                    <tr>
                                        <th class="th-first-modal-border-fix"></th>
                                        <th class="text-left" :colspan="colspan">
                                            {{ __('payment_transfer_to_another_department') }}
                                        </th>
                                        <th class="text-right">{{ __('allocated') }}</th>
                                        <th>{{ __('currency') }} ({{ __('payments') }})</th>
                                        <th></th>
                                        <th></th>
                                        <th class="th-before th-last"></th>
                                    </tr>
                                </thead>

                                <tbody
                                    class="border-top-0"
                                    v-if="modalType !== 'noContractor'"
                                    v-for="(department, index) in operationDepartments"
                                    :key="department.id"
                                >
                                    <tr
                                        class="row-one-line border-bottom"
                                        v-if="forceDepartment == false && (isCurrentDepartmentVisible(department) || department.deletable)"
                                    >
                                        <td class="td-padding" v-if="!department.deletable">
                                            <input
                                                type="checkbox"
                                                class="line-checkbox"
                                                :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                                                v-model="operationDepartments[index].checked"
                                                :disabled="operationDepartments[index].disabled || disabled"
                                                @change="handleDepartmentCheckboxChange(index)"
                                            >
                                        </td>
                                        <td class="td-padding table-icons" v-else>
                                            <a
                                                data-type="payment-correction"
                                                :class="{disabledIcon: disabled}"
                                                @click="handleDepartmentDelete(index, department.id)"
                                            >
                                                <i class="fa fa-trash"></i>
                                            </a>
                                        </td>
                                        <td class="td-padding text-left title" :colspan="colspan">
                                            {{ __('department') }} {{ department.name }}
                                        </td>
                                        <td :class="{'has-error' : rowHasError(index, 'departments')}">
                                            <input
                                                class="form-control text-right split split-amount money"
                                                type="text"
                                                placeholder="0,00"
                                                :readonly="operationDepartments[index].readonly"
                                                :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                                                v-model="operationDepartments[index].amount"
                                                @change="handleDepartmentAmountChanged(index)"
                                                :disabled="disabled"
                                            >
                                        </td>
                                        <td class="td-padding">{{ source.currency }}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr
                                        class="row-one-line border-bottom"
                                        v-else-if="forceDepartment==true && department.forceVisible"
                                    >
                                        <td class="td-padding" v-if="!department.deletable">
                                            <input
                                                type="checkbox"
                                                class="line-checkbox"
                                                :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                                                v-model="operationDepartments[index].checked"
                                                :disabled="operationDepartments[index].disabled || disabled"
                                                @change="handleDepartmentCheckboxChange(index)"
                                            >
                                        </td>
                                        <td class="td-padding table-icons" v-else>
                                            <a
                                                data-type="payment-correction"
                                                :class="{disabledIcon: disabled}"
                                                @click="handleDepartmentDelete(index)"
                                            >
                                                <i class="fa fa-trash"></i>
                                            </a>
                                        </td>
                                        <td class="td-padding text-left title" :colspan="colspan">
                                            {{ __('department') }} {{ department.name }}
                                        </td>
                                        <td :class="{'has-error' : rowHasError(index, 'departments')}">
                                            <input
                                                class="form-control text-right split split-amount money"
                                                type="text"
                                                placeholder="0,00"
                                                :readonly="operationDepartments[index].readonly"
                                                :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                                                v-model="operationDepartments[index].amount"
                                                @change="handleDepartmentAmountChanged(index)"
                                                :disabled="disabled"
                                            >
                                        </td>
                                        <td class="td-padding">{{ source.currency }}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr class="tr-errors" v-show="rowHasError(index, 'departments')">
                                        <td v-if="modalType === 'globalContractor'" colspan="5"></td>
                                        <td v-else colspan="7"></td>
                                        <td>
                                        <span v-show="rowHasError(index, 'departments')" class="help-block text-danger">
                                            {{ getErrorMessage(index, 'departments')[0] }}
                                        </span>
                                                </td>
                                                <td></td>
                                                <td>
                                       <span v-show="rowHasError(index, 'departments') && getErrorMessage(index, 'departments').length > 1" class="help-block text-danger">
                                            {{ getErrorMessage(index, 'departments')[1] }}
                                        </span>
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr class="row-one-line" v-if="departments.length === 0">
                                        <td class="td-padding"></td>
                                        <td class="td-padding" colspan="3">{{ __('no_other_departments_found') }}</td>
                                    </tr>
                                </tbody>
                                <thead v-if="!isDepartmentTransfer && operationCategories.length > 0 && (modalType === 'localContractor' || modalType === 'noContractor') &&  ((operation.id > 0 && modalContext.categoryAllocations.length > 0 || operation.id < 0))">
                                    <tr>
                                        <th class="th-first-modal-border-fix"></th>
                                        <th class="title text-left"
                                            :colspan="colspan">
                                            {{ __('costs_and_incomes_directly_from_statement') }}
                                        </th>
                                        <th class="text-right">{{ __('allocated') }}</th>
                                        <th class="">{{ __('currency') }} ({{ __('payments') }})</th>
                                        <th class="text-right">{{ __('exchange_rate') }}</th>
                                        <th class="text-right">{{ __('calculated_amount') }}</th>
                                        <th class="th-before th-last">{{ __('currency') }}</th>
                                    </tr>
                                </thead>
                                <tbody v-if="!isDepartmentTransfer && operationCategories.length > 0 && (modalType === 'localContractor' || modalType === 'noContractor') &&  ((operation.id > 0 && modalContext.categoryAllocations.length > 0 || operation.id < 0))" >
                                    <tr class="row-one-line border-bottom"
                                        v-for="(category, index) in operationCategories">
                                        <td class="td-padding">
                                            <input
                                                type="checkbox"
                                                data-type="single"
                                                class="line-checkbox category-split"
                                                :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                                                v-model="operationCategories[index].checked"
                                                :disabled="operationCategories[index].disabled || disabled"
                                                @change="handleCategoryCheckboxChange(index)"
                                            >
                                        </td>
                                        <td class="td-padding text-left title" :colspan="colspan">
                                            {{ category.name }}&nbsp;({{ __(category.type) }})
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                class="form-control money split split-amount text-right"
                                                placeholder="0,00" readonly
                                                :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                                                :data-exchange="!source.currency_is_default ? 1 : 0"
                                                :data-autofill="true"
                                                :data-type="'single'"
                                                v-model="operationCategories[index].amount"
                                                :disabled="disabled"
                                            >
                                        </td>
                                        <td class="td-padding">{{ source.currency }}</td>
                                        <td>
                                            <input
                                                v-if="!source.currency_is_default && useExchangeRates"
                                                placeholder="1,0000"
                                                class="form-control money exchange-rate text-right"
                                                v-model="operationCategories[index].exchange_rate"
                                                :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                                                :disabled="disabled"
                                                :readonly="!operationCategories[index].checked && !operation.currency_is_default"
                                                @change="handleCategoryExchangeRateChange(index)"
                                            >
                                        </td>
                                        <td>
                                            <input
                                                v-if="!source.currency_is_default"
                                                readonly
                                                class="form-control money text-right exchanged-amount"
                                                v-model="operationCategories[index].exchanged_amount"
                                                :disabled="disabled"
                                            >
                                        </td>
                                        <td v-if="!source.currency_is_default" class="td-padding" :colspan="colspan">
                                            {{ defaultCurrency.iso_code }}
                                        </td>
                                        <td v-else></td>
                                    </tr>
                                </tbody>
                                <thead v-if="modalType !== 'noContractor'">
                                    <tr>
                                        <th class="th-first-modal-border-fix"></th>
                                        <th class="text-left" :colspan="colspan">
                                            {{ __('payment_on_behalf_of_another_contractor') }}
                                        </th>
                                        <th class="text-right">{{ __('allocated') }}</th>
                                        <th>{{ __('currency') }} ({{ __('payments') }})</th>
                                        <th v-if="(showAdditionalHeaders && useExchangeRates) || operationContractorTransferHasCurrencyExchange()">{{__('exchange_rate')}}</th>
                                        <th v-else></th>

                                        <th v-if="showAdditionalHeaders || operationContractorTransferHasCurrencyExchange()">{{__('calculated_amount')}}</th>
                                        <th v-else></th>

                                        <th class="th-before th-last" v-if="showAdditionalHeaders || operationContractorTransferHasCurrencyExchange()">{{__('currency')}}</th>
                                        <th class="th-before th-last" v-else></th>
                                    </tr>
                                </thead>
                                <tbody class="contractor-split"
                                       v-if="modalType !== 'noContractor'"
                                       v-for="(operationContractorTransfer, contractorTransferIndex) in clearOperationContractorTransfers"
                                       :key="operationContractorTransfer.unique">
                                    <tr
                                        class="row-odd row-one-line border-bottom contractor-select-row"
                                        v-if="!operationContractorTransfer.to_delete"
                                    >
                                        <td class="td-padding text-left" :colspan="6">
                                            <select2 v-if="(!operationContractorTransfer.checked && !contractorHasOtherTransfer(operationContractorTransfer.contractor_id)) || operationContractorTransfer.contractor_id == 0"
                                                :settings="{ width: modalType === 'localContractor'? '400px' : '300px'}"
                                                :dropdownParent="selectContainer"
                                                :options="contractorsForTransfers"
                                                v-model="operationContractorTransfer.contractor_id"
                                                @change="handleContractorTransferSelectChanged(contractorTransferIndex, operationContractorTransfer.unique)">
                                            </select2>
                                            <input v-else class="form-control" type="text" :style="{ width: (modalType === 'localContractor'? 400 : 300) + 'px !important'}" :value="getContractorName(operationContractorTransfer.contractor_id).text" disabled data-toggle="tooltip" data-placement="top" title=""
                                                   :data-original-title="getContractorName(operationContractorTransfer.contractor_id).text">
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td v-if="modalType === 'localContractor'"></td>
                                        <td v-if="modalType === 'localContractor'"></td>
                                        <td class="td-padding"></td>
                                    </tr>
                                    <modal-document-line
                                        v-for="(transferDocument, index) in operationTransfersDocumentsForContractor(operationTransfersDocuments[operation.id], operationContractorTransfer.contractor_id)"
                                        :index="index"
                                        @showAdditionalHeaders="showAdditionalHeadersInDocuments()"
                                        :has-error="rowHasError(index, 'contractorTransfers')"
                                        :error-message="getErrorMessage(index, 'contractorTransfers')"
                                        :colspan="colspan"
                                        :document="transferDocument"
                                        :operation="operation"
                                        :method="method"
                                        :context="dynamicContent"
                                        :modal-type="modalType"
                                        :total-allocated="totalAllocated"
                                        :modalVisible="modalVisible"
                                        :disabled="disabled"
                                        :document-type="'contractorDocument'"
                                        :key="transferDocument.flow_connection_id"
                                        @documentAllocationChanged="handleTransferDocumentAllocationChanged"
                                        @documentDeleted="handleTransferDocumentDelete($event, operationContractorTransfer, transferDocument, contractorTransferIndex, index, operationContractorTransfer.contractor_id)">
                                    </modal-document-line>

                                    <tr
                                        class="row-one-line border-bottom payment-correction"
                                        v-for="(correction, index) in getTransferPaymentCorrectionsForContractor(operationContractorTransfersCorrections, operationContractorTransfer.contractor_id)"
                                    >
                                        <td class="td-padding table-icons">
                                            <a
                                                class="icon-delete-embedded"
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                data-type="payment-correction"
                                                :class="{disabledIcon: disabled}"
                                                @click="handleTransferPaymentCorrectionDelete(correction, contractorTransferIndex, true, operationContractorTransfer.contractor_id)"
                                            >
                                                <i class="fa fa-trash"></i>
                                            </a>
                                        </td>
                                        <td class="td-padding text-left title" :colspan="colspan">
                                            {{ __('incorrect_payment_refund') }}{{correction.target.description !== null ? (': ' + correction.target.description): ''}}
                                        </td>
                                        <td>
                                            <input
                                                class="form-control text-right split split-amount money"
                                                type="text"
                                                placeholder="0,00"
                                                :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                                                :title="__('incorrect_payment_refund')"
                                                :name="'[payment-correction]'"
                                                :value="getCorrectionAmount(correction) | localizeMoney"
                                                readonly
                                            >
                                        </td>
                                        <td class="td-padding">{{ source.currency }}</td>
                                        <td v-if="correction.exchange_rate !== null">
                                            <input
                                                placeholder="1,0000"
                                                class="form-control money exchange-rate text-right"
                                                :value="correction.exchange_rate | localizeExchangeRate"
                                                :disabled="disabled"
                                                :readonly="true"
                                            >
                                        </td>
                                        <td v-else></td>
                                        <td v-if="correction.exchange_rate !== null || operationContractorTransferHasCurrencyExchange()">
                                            <input
                                                readonly
                                                class="form-control money text-right exchanged-amount"
                                                :value="correction.target_amount | localizeMoney"
                                                :disabled="disabled"
                                            >
                                        </td>
                                        <td v-else></td>
                                        <td v-if="correction.exchange_rate !== null || operationContractorTransferHasCurrencyExchange()">{{correction.target.document_currency}}</td>
                                        <td v-else></td>
                                    </tr>
                                    <tr
                                        class="row-one-line border-bottom payment-correction"
                                        v-for="(correction, index) in getTransferCurrencyExchangesForContractor(operationContractorTransfersCurrencyExchanges, operationContractorTransfer.contractor_id)"
                                    >
                                        <td class="td-padding table-icons">
                                            <a
                                                class="icon-delete-embedded"
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                data-type="payment-correction"
                                                :class="{disabledIcon: disabled}"
                                                @click="handleTransferCurrencyExchangeDelete(correction, contractorTransferIndex, true, operationContractorTransfer.contractor_id)"
                                            >
                                                <i class="fa fa-trash"></i>
                                            </a>
                                        </td>
                                        <td class="td-padding text-left title"
                                            :colspan="colspan">
                                            {{ __('currency_exchange') }}{{correction.target.description !== null ? (': ' + correction.target.description): ''}}
                                        </td>
                                        <td>
                                            <input
                                                class="form-control text-right split split-amount money" type="text"
                                                placeholder="0,00"
                                                title="[payment-correction]"
                                                :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                                                :value="getCorrectionAmount(correction) | localizeMoney" readonly>
                                        </td>
                                        <td class="td-padding">{{ source.currency }}</td>
                                        <td v-if="correction.exchange_rate !== null">
                                            <input
                                                placeholder="1,0000"
                                                class="form-control money exchange-rate text-right"
                                                :value="correction.exchange_rate | localizeExchangeRate"
                                                :disabled="disabled"
                                                :readonly="true"
                                            >
                                        </td>
                                        <td v-else></td>
                                        <td v-if="correction.exchange_rate !== null || operationContractorTransferHasCurrencyExchange()">
                                            <input
                                                readonly
                                                class="form-control money text-right exchanged-amount"
                                                :value="correction.target_amount | localizeMoney"
                                                :disabled="disabled"
                                            >
                                        </td>
                                        <td v-else></td>
                                        <td v-if="correction.exchange_rate !== null || operationContractorTransferHasCurrencyExchange()">{{correction.target.document_currency}}</td>
                                        <td v-else></td>
                                    </tr>
                                    <tr
                                        class="row-odd row-one-line border-bottom contractor-row"
                                        v-if="operationContractorTransfer.contractor_id != 0"
                                    >
                                        <td class="td-padding" >
                                            <input
                                                type="checkbox"
                                                class="add-contractor-split line-checkbox"
                                                v-model="operationContractorTransfers[contractorTransferIndex].checked"
                                                @change="handleContractorTransferChecked(contractorTransferIndex, clearOperationContractorTransfers[contractorTransferIndex].local_balance, operationContractorTransfer.contractor_id, clearOperationContractorTransfers[contractorTransferIndex])"
                                                :disabled="disabled"
                                            >
                                        </td>
                                        <td class="td-padding text-left title" :colspan="colspan">
                                            <span>
                                                {{
                                                    isContractorGlobal(operationContractorTransfers[contractorTransferIndex].contractor_id) ? __('payments_for_contractor_documents') : __('not_allocated_payments_from_contractor')
                                                }}
                                            </span>
                                        </td>
                                        <td :class="{'has-error' : rowHasError(contractorTransferIndex, 'contractorTransfers')}">
                                            <input
                                                type="text"
                                                class="form-control text-right split split-amount money contractor-split-amount "
                                                placeholder="0,00"
                                                :readonly="!operationContractorTransfers[contractorTransferIndex].checked"
                                                v-model="clearOperationContractorTransfers[contractorTransferIndex].local_balance"
                                                :disabled="disabled"
                                                @change="handleContractorTransferAmountChanged(contractorTransferIndex, clearOperationContractorTransfers[contractorTransferIndex].local_balance, operationContractorTransfer.contractor_id, clearOperationContractorTransfers[contractorTransferIndex])"
                                                style="text-align: right;">
                                        </td>
                                        <td class="td-padding">
                                            {{ operationContractorTransfers[contractorTransferIndex].currency }}
                                        </td>
                                    </tr>
                                    <tr class="tr-errors" v-show="rowHasError(contractorTransferIndex, 'contractorTransfers')">
                                        <td colspan="7"></td>
                                        <td>
                                        <span v-show="rowHasError(contractorTransferIndex, 'contractorTransfers')" class="help-block text-danger">
                                            {{ getErrorMessage(contractorTransferIndex, 'contractorTransfers')[0] }}
                                        </span>
                                        </td>
                                        <td></td>
                                        <td>
                                       <span v-show="rowHasError(contractorTransferIndex, 'contractorTransfers') && getErrorMessage(contractorTransferIndex, 'contractorTransfers').length > 1" class="help-block text-danger">
                                            {{ getErrorMessage(contractorTransferIndex, 'contractorTransfers')[1] }}
                                        </span>
                                        </td>
                                        <td></td>
                                    </tr>
                                </tbody>
                                <thead v-if="modalType !== 'globalContractor' && !isDepartmentTransfer && ((operation.id > 0 && isSourceTransfers() || operation.id < 0))">
                                    <tr>
                                        <th class="th-first-modal-border-fix"></th>
                                        <th class="text-left" :colspan="colspan">
                                            {{ __('transfer_between_sources') }}
                                        </th>
                                        <th class="text-right">{{ __('allocated') }}</th>
                                        <th>{{ __('currency') }} ({{ __('payments') }})</th>
                                        <th></th>
                                        <th></th>
                                        <th class="th-before th-last"></th>
                                    </tr>
                                </thead>
                                <tbody v-if="modalType !== 'globalContractor' && !isDepartmentTransfer && ((operation.id > 0 && isSourceTransfers() || operation.id < 0))">
                                    <tr class="row-odd row-one-line">
                                        <td class="td-padding">
                                            <input
                                                type="checkbox"
                                                name="[source_transfer][checkbox]"
                                                data-type="single"
                                                data-save-action="resetContractor"
                                                class="line-checkbox"
                                                :disabled="operationSourceTransfer.disabled || disabled"
                                                v-model="operationSourceTransfer.checked"
                                                @change="handleSourceTransferCheckboxChange">
                                        </td>
                                        <td class="td-padding text-left title"
                                            :colspan="colspan">
                                            {{ __('transfer_between_sources') }}
                                        </td>
                                        <td>
                                            <input
                                                class="form-control text-right money split-amount split source-transfer"
                                                type="text" placeholder="0,00" readonly
                                                :title="__('transfer_between_sources')"
                                                data-type="single"
                                                :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                                                :data-autofill="true"
                                                v-model="operationSourceTransfer.amount">
                                        </td>
                                        <td class="td-padding">{{ source.currency }}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                                <thead
                                    class="payment-correction-header"
                                    v-if="(hasCorrection() || hasGenerateBalance()) && modalType === 'localContractor'"
                                >
                                    <tr>
                                        <th class="th-first-modal-border-fix"></th>
                                        <th class="text-left" :colspan="colspan"> {{ __('others') }}</th>
                                        <th class="text-right">{{ __('allocated') }}</th>
                                        <th>{{ __('currency') }} ({{ __('payments') }})</th>
                                        <th v-if="oneOfOtherHasExchangeRate()">{{ __('exchange_rate') }}</th>
                                        <th v-else></th>
                                        <th v-if="oneOfOtherHasExchangeRate()">{{ __('calculated_amount') }}</th>
                                        <th v-else></th>
                                        <th v-if="oneOfOtherHasExchangeRate()" class="th-before th-last">
                                            {{ __('currency') }}</th>
                                        <th v-else class="th-before th-last"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        class="row-one-line border-bottom payment-correction"
                                        v-for="(correction, index) in operationPaymentCorrections"
                                    >
                                        <td class="td-padding table-icons">
                                            <a
                                                class="icon-delete-embedded"
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                data-type="payment-correction"
                                                :class="{disabledIcon: disabled}"
                                                @click="handlePaymentCorrectionDelete(index)"
                                            >
                                                <i class="fa fa-trash"></i>
                                            </a>
                                        </td>
                                        <td class="td-padding text-left title wrap-text-inside-td" :colspan="colspan">
                                            {{ __('incorrect_payment_refund') }}{{correction.target.description !== null ? (': ' + correction.target.description): ''}}
                                        </td>
                                        <td>
                                            <input
                                                class="form-control text-right split split-amount money"
                                                type="text"
                                                placeholder="0,00"
                                                :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                                                :title="__('incorrect_payment_refund')"
                                                :name="'[payment-correction]'"
                                                :value="getCorrectionAmount(correction) | localizeMoney"
                                                readonly>
                                        </td>
                                        <td class="td-padding">{{ source.currency }}</td>
                                        <td v-if="correction.exchange_rate !== null">
                                            <input
                                                placeholder="1,0000"
                                                class="form-control money exchange-rate text-right"
                                                :value="correction.exchange_rate | localizeExchangeRate"
                                                :disabled="disabled"
                                                :readonly="true"
                                            >
                                        </td>
                                        <td v-else></td>
                                        <td v-if="correction.exchange_rate !== null || correction.source_amount != correction.target_amount">
                                            <input
                                                readonly
                                                class="form-control money text-right exchanged-amount"
                                                :value="correction.target_amount | localizeMoney"
                                                :disabled="disabled"
                                            >
                                        </td>
                                        <td v-else></td>
                                        <td v-if="correction.exchange_rate !== null || correction.source_amount != correction.target_amount">{{correction.target.document_currency}}</td>
                                        <td v-else></td>
                                    </tr>
                                    <tr
                                        class="row-one-line border-bottom payment-correction"
                                        v-for="(correction, index) in operationPaymentCorrectionsOffsets"
                                    >
                                        <td class="td-padding table-icons">
                                            <a
                                                class="icon-delete-embedded"
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                data-type="payment-correction"
                                                :class="{disabledIcon: disabled}"
                                                @click="handlePaymentCorrectionOffsetDelete(index)"
                                            >
                                                <i class="fa fa-trash"></i>
                                            </a>
                                        </td>
                                        <td class="td-padding text-left title"
                                            :colspan="colspan">
                                            {{ __('incorrect_payment_refund') }}
                                        </td>
                                        <td>
                                            <input
                                                class="form-control text-right split split-amount money"
                                                type="text"
                                                placeholder="0,00"
                                                name="[payment-offset]"
                                                :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                                                :title="__('incorrect_payment_refund')"
                                                :value="getCorrectionOffsetAmount(correction) | localizeMoney"
                                                readonly
                                            >
                                        </td>
                                        <td class="td-padding">{{ source.currency }}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr
                                        class="row-one-line border-bottom payment-correction"
                                        v-for="(correction, index) in operationCurrencyExchanges"
                                    >
                                        <td class="td-padding table-icons">
                                            <a
                                                class="icon-delete-embedded"
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                data-type="payment-correction"
                                                :class="{disabledIcon: disabled}"
                                                @click="handleCurrencyExchangeDelete(index)"
                                            >
                                                <i class="fa fa-trash"></i>
                                            </a>
                                        </td>
                                        <td class="td-padding text-left title wrap-text-inside-td"
                                            :colspan="colspan">
                                            {{ __('currency_exchange') }}{{correction.target.description !== null ? (': ' + correction.target.description): ''}}
                                        </td>
                                        <td>
                                            <input
                                                class="form-control text-right split split-amount money"
                                                type="text"
                                                placeholder="0,00"
                                                title="[payment-correction]"
                                                :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                                                :value="getCorrectionAmount(correction) | localizeMoney" readonly
                                            >
                                        </td>
                                        <td class="td-padding">{{ source.currency }}</td>
                                        <td v-if="correction.exchange_rate !== null ">
                                            <input
                                                placeholder="1,0000"
                                                class="form-control money exchange-rate text-right"
                                                :value="correction.exchange_rate | localizeExchangeRate"
                                                :disabled="disabled"
                                                :readonly="true"
                                            >
                                        </td>
                                        <td v-else></td>
                                        <td v-if="correction.exchange_rate !== null || correction.source_amount != correction.target_amount">
                                            <input
                                                readonly
                                                class="form-control money text-right exchanged-amount"
                                                :value="correction.target_amount | localizeMoney"
                                                :disabled="disabled"
                                            >
                                        </td>
                                        <td v-else></td>
                                        <td v-if="correction.exchange_rate !== null || correction.source_amount != correction.target_amount">{{correction.target.document_currency}}</td>
                                        <td v-else></td>
                                    </tr>
                                    <tr
                                        class="row-one-line border-bottom payment-correction"
                                        v-for="(correction, index) in operationCurrencyExchangesOffsets"
                                    >
                                        <td class="td-padding table-icons">
                                            <a
                                                class="icon-delete-embedded"
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                data-type="payment-correction"
                                                :class="{disabledIcon: disabled}"
                                                @click="handleCurrencyExchangeOffsetDelete(index)"
                                            >
                                                <i class="fa fa-trash"></i>
                                            </a>
                                        </td>
                                        <td class="td-padding text-left title"
                                            :colspan="colspan">
                                            {{ __('currency_exchange') }}
                                        </td>
                                        <td>
                                            <input
                                                class="form-control text-right split split-amount money"
                                                type="text"
                                                placeholder="0,00"
                                                name="[payment-offset]"
                                                :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                                                :title="__('currency_exchange')"
                                                :value="getCorrectionOffsetAmount(correction) | localizeMoney"
                                                readonly
                                            >
                                        </td>
                                        <td class="td-padding">{{ source.currency }}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr
                                        class="row-odd row-one-line border-bottom payment-correction"
                                        v-if="hasGenerateBalance()" v-for="(ogb, index) in operationGeneratedBalance"
                                    >
                                        <td class="td-padding table-icons">
                                            <a
                                                class="icon-delete-embedded"
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                data-type="payment-correction"
                                                :class="{disabledIcon: disabled}"
                                                @click="handleGeneratedBalanceDelete(ogb.id, ogb.amount)"
                                            >
                                                <i class="fa fa-trash"></i>
                                            </a>
                                        </td>
                                        <td class="td-padding text-left title" :colspan="colspan">
                                            {{ __('generated_balance_operation') }}{{ogb.description !== null ? (': ' + ogb.description): ''}}
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                class="form-control text-right split money"
                                                placeholder="0,00"
                                                readonly
                                                name="[payment-offset]"
                                                :title="__('generated_balance_operation')"
                                                :value="ogb.amount | localizeMoney"
                                            >
                                        </td>
                                        <td class="td-padding">{{ source.currency }}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                              <thead v-if="!isDepartmentTransfer && modalType !== 'globalContractor' &&  modalType !== 'noContractor'&& operation.id < 0 && (source.payment_type_name=='bank_account' || source.payment_type_name==='safe') && source.currency_is_default ">
                              <tr>
                                <th class="th-first-modal-border-fix"></th>
                                <th class="text-left">
                                  Nowy dokument dla operacji
                                </th>
                                <th class="text-right" colspan="2">Numer dokumentu</th>
                                <th colspan="3">Nazwa towaru/usługi</th>
                                <th>Połączono</th>
                                <th>Waluta (Płatności)</th>
                                  <th></th>
                                  <th></th>
                                <th class="th-before th-last"></th>
                              </tr>
                              </thead>
                              <tbody v-if="modalType !== 'globalContractor' &&  modalType !== 'noContractor'&& operation.id < 0 && (source.payment_type_name=='bank_account' || source.payment_type_name==='safe') && source.currency_is_default">
                              <tr class="row-odd row-one-line">
                                <td class="td-padding">
                                  <input
                                      type="checkbox"
                                      name="[new_document_for_operation][checkbox]"
                                      data-type="single"
                                      data-save-action="resetContractor"
                                      class="line-checkbox"
                                      :disabled="newDocumentForOperation.disabled || disabled"
                                      v-model="newDocumentForOperation.checked"
                                      @change="handleNewDocumentForOperationChanged()"
                                      >
                                </td>
                                <td class="td-padding text-left title"
                                    >
                                  Nowy dokument dla operacji
                                </td>
                                <td class="tr-errors"  colspan="2" :class="{'has-error' : rowHasError(0, 'newDocumentForOperation', true) && getErrorMessage(0, 'newDocumentForOperation', true)[2] !== ''}">
                                  <input
                                      class="form-control"
                                      type="text" placeholder=""
                                      :title="__('transfer_between_sources')"
                                      data-type="single"
                                      :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                                      :data-autofill="true"
                                      v-model="newDocumentForOperation.document_number"
                                      :disabled="disabledFieldsForNewDocumentOperation">
                                </td>
                                <td colspan="3" :class="{'has-error' : rowHasError(0, 'newDocumentForOperation',true) && getErrorMessage(0, 'newDocumentForOperation', true)[3] !== ''}">    <input
                                    class="form-control text-right"
                                    type="text"
                                    :title="__('transfer_between_sources')"
                                    data-type="single"
                                    :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                                    :data-autofill="true"
                                    :disabled="disabledFieldsForNewDocumentOperation"
                                    v-model="newDocumentForOperation.name_of_service">
                                </td>
                                <td :class="{'has-error' : rowHasError(0, 'newDocumentForOperation',true)}">
                                    <input
                                    class="form-control text-right money split-amount split source-transfer"
                                    type="text" placeholder="0,00"
                                    :title="__('transfer_between_sources')"
                                    data-type="single"
                                    :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                                    :data-autofill="true"
                                    :disabled="disabledFieldsForNewDocumentOperation"
                                    v-model="newDocumentForOperation.amount"
                                   @change="handleNewDocumentAmountChanged()"></td>
                                <td class="td-padding"> {{ source.currency }}</td>
                                <td></td>
                                  <td></td>
                              </tr>
                              <tr class="tr-errors" v-show="rowHasError(0, 'newDocumentForOperation',true)">
                                  <td :colspan="2"></td>
                                  <td :colspan="2">
                                        <span v-show="rowHasError(0, 'newDocumentForOperation',true)" class="help-block text-danger">
                                            {{ getErrorMessage(0, 'newDocumentForOperation', true)[2] }}
                                        </span>
                                  </td>
                                  <td :colspan="3">
                                       <span v-show="rowHasError(0, 'newDocumentForOperation',true) " class="help-block text-danger">
                                            {{ getErrorMessage(0, 'newDocumentForOperation', true)[3] }}
                                        </span>
                                  </td>
                                  <td>
                                       <span v-show="rowHasError(0, 'newDocumentForOperation',true)" class="help-block text-danger">
                                            {{ getErrorMessage(0, 'newDocumentForOperation', true)[0] }}
                                        </span>
                                  </td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                              </tr>
                              </tbody>
                                <thead>
                                    <tr>
                                        <th class="th-first-modal-border-fix"></th>
                                        <th class="text-left"
                                            :colspan="colspan">
                                            {{
                                                (modalType === 'localContractor' ||  modalType === 'noContractor') ? __('unallocated_payments') : __('document_payments')
                                            }}
                                        </th>
                                        <th class="text-right">{{ __('allocated') }}</th>
                                        <th>{{ __('currency') }} ({{ __('payments') }})</th>
                                        <th></th>
                                        <th></th>
                                        <th class="th-before th-last"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="row-odd row-one-line">
                                        <td class="td-padding"></td>
                                        <td class="td-padding text-left"
                                            :colspan="colspan">
                                            {{
                                                (modalType === 'localContractor' || modalType === 'noContractor') ? (modalType === 'localContractor' ? __('unallocated_payments') : __('for_split') ) : __('document_payments')
                                            }}
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                class="form-control text-right left-for-split"
                                                placeholder="0,00"
                                                readonly
                                                :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                                                :title="modalType === 'localContractor' ? __('unallocated_payments') : __('for_split')"
                                                v-model="leftForSplit">
                                        </td>
                                        <td class="td-padding">{{ source.currency }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:modal-footer="{}">
                <div class="row m-b">
                    <div class="col-md-12 text-right">
                        <button type="button" class="btn btn-white cancel-and-refresh" v-on:click="restoreModal">
                            {{ __('cancel') }}
                        </button>
                        <button
                            v-if="method!=='show'"
                            type="submit"
                            class="btn btn-primary m-r save-connect-with"
                            :disabled="!isFilled || method==='show'"
                            @click="save"
                        >
                            <span>
                                {{ !isDepartmentTransfer || method === 'show' ? __('save') : __('save') }}
                            </span>
                        </button>
                    </div>
                </div>
            </template>
        </b-modal>
    </fragment>
</template>

<script>
import $ from 'jquery';
import mutations from "../../vuex/payments/mutation_types";
import {Money} from "../../services/Money";
import events from "../../services/Events";
import ModalDocumentLine from "./ModalDocumentLine";
import store from "../../vuex/store";
import filters from "../../services/Filters";
import Allocation from "../../helpers/allocation";
import actions from "../../vuex/action_types";
import HelpModal from '../../components/help/HelpModal.vue';
import ButtonOpenHelpModal from '../../components/help/ButtonOpenHelpModal.vue';
import {Fragment} from 'vue-fragment';

export default {
    name: "OperationConnectWithModal",
    components: {ModalDocumentLine, HelpModal, ButtonOpenHelpModal, Fragment},
    props: {
        operation: {
            type: Object,
            required: true,
        },
        method: {
            type: String,
            required: true,
        },
        actionType: {
            type: String,
            required: true,
        },
        operationIndex: {
            required: true,
        },
        groupName: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        },
        isDepartmentTransfer: {
            type: Boolean,
            default: false
        },
        helpName: {
            type: String,
            default: null
        },

    },
    filters: filters,
    data: function () {
        return {
            forceDepartment: false,
            transferToDepartmentAmount : 0,
            transferTargetDepartment: null,
            selectContainer: $('#modalContent'),
            errors: {},
            title: '',
            showAdditionalHeaders: false,
            modalType: 'localContractor',
            modalVisible: false,
            dynamicContent: [],
            modalSize: 'xl',
            colspan: '6',
            contractorIds: [],
            money: new Money(),
            blankAllocationTransferAllocationId: 0,
            blankContractorTransfer: {
                checked: false,
                id: 0,
                amount: '0,00',
                currency: this.operation.currency,
                exchange_rate: '1,00',
                exchanged_amount: '0,00',
                exchange_target_currency: 'PLN',
                last_value : 0,
                contractor_id: 0,
                local_balance: '0,00',
                to_delete: false,
            },
            clearOperationContractorTransfers: [],
            operationDocuments: [],
            operationProformas:[],
            operationDocumentsPayments: {},
            operationDepartments: [],
            operationDepartmentTransfers: [],
            operationCategories: [],
            operationContractorTransfers: [],
            operationTransfersDocuments: {},
            operationContractorTransfersCorrections: [],
            operationContractorTransfersCorrectionsOffsets: [],
            operationContractorTransfersCurrencyExchanges: [],
            operationContractorTransfersCurrencyExchangesOffsets: [],
            operationSourceTransfer: {},
            newDocumentForOperation: { checked: false,amount:"0,00"},
            operationPaymentCorrections: [],
            operationPaymentCorrectionsOffsets: [],
            operationCurrencyExchanges: [],
            operationCurrencyExchangesOffsets: [],
            operationGeneratedBalance: {},
            isFilled: true,
            leftForSplit: 0,
            totalAllocated: 0,
            allocatedAmounts: {
                documentAllocations: [],
                proformaAllocations:[],
                departments: [],
                categories: [],
                contractorTransfers: [],
                transferBetweenSources: [],
                documentsPayments: [],
                paymentCorrections: [],
                paymentCorrectionsOffsets: [],
                currencyExchanges: [],
                currencyExchangesOffsets: [],
                generateBalance: [],
                newDocumentForOperation : [],
            },
            contractorTransfersAllocatedAmounts: [],
            contractorTransferAllocatedAmountsStruct: {
                contractorTransfersDocuments: [],
                contractorTransfersPaymentCorrections: [],
                contractorTransfersPaymentCorrectionsOffsets: [],
                contractorTransfersCurrencyExchanges: [],
                contractorTransfersCurrencyExchangesOffsets: [],
            },
            stateToCommit: {
                proformaAllocations:[],
                documentAllocations: [],
                departments: [],
                categories: [],
                contractorTransfers: [],
                contractorTransfersDocuments: [],
                transferBetweenSources: [],
                documentsPayments: [],
                paymentCorrections: [],
                paymentCorrectionsOffsets: [],
                currencyExchanges: [],
                currencyExchangesOffsets: [],
                correctionsForDelete: [],
                correctionsOffsetsForDelete: [],
                currencyExchangesForDelete: [],
                currencyExchangesOffsetForDelete: [],
                transferDocumentsForDelete: [],
                generatedBalanceForDelete: [],
                newDocumentForOperation : [],
            },
            dynamicDocumentsBalance: {}
        }
    },
    watch: {
        operation: {
            handler(val) {
                this.calculateTotalAllocated();
                this.calculateLeftForSplit();
                this.updateStateToCommitAllocations();
                this.updateStateLeftForSplit();
            },
            deep: true
        },
        operationIndex: function (val) {
            this.operation.index = val;
            this.sendToStore();
        }
    },
    methods: {
        operationAmountGtZero:function (){
            return this.money.toFloat(this.operation.formatted_amount) > 0
        },
        checkDestroyContractorSection: function (contractor_id){
            if(!this.contractorHasOtherTransfer(contractor_id)){
                let indexOfClearOperation = this.clearOperationContractorTransfers.findIndex((item) => {
                    return item.contractor_id == contractor_id && item.checked == false;
                })
                if(indexOfClearOperation >= 0){
                    this.clearOperationContractorTransfers.splice(indexOfClearOperation, 1)
                }
                let indexOfOperationTransfer = this.operationContractorTransfers.findIndex((item) => {
                    return item.contractor_id == contractor_id && item.checked == false;
                })
                if(indexOfOperationTransfer >= 0){
                    this.operationContractorTransfers.splice(indexOfOperationTransfer, 1)
                }

                if(this.clearOperationContractorTransfers.length == 0){
                    let blankContactorTransfer = {...this.blankContractorTransfer};
                    blankContactorTransfer.unique = Date.now();
                    this.operationContractorTransfers.push(blankContactorTransfer);
                    this.clearOperationContractorTransfers.push(blankContactorTransfer)
                }

            }
        },
        operationContractorTransferHasCurrencyExchange:function (){
            if(this.operationContractorTransfersCorrections.length > 0){
                let operationPaymentCorrectionsWithExchangeRate =  this.operationContractorTransfersCorrections.filter(flow_connection => {
                    return flow_connection.exchange_rate != null || (flow_connection.source.currency_is_default == false  && flow_connection.source.currency != flow_connection.target.document_currency);
                });
                if(operationPaymentCorrectionsWithExchangeRate.length > 0){
                    return true;
                }
            }
            if(this.operationContractorTransfersCurrencyExchanges.length > 0){
                let operationCurrencyExchangesWithExchangeRate =  this.operationContractorTransfersCurrencyExchanges.filter(flow_connection => {
                    return flow_connection.exchange_rate != null || (flow_connection.source.currency_is_default == false  && flow_connection.source.currency != flow_connection.target.document_currency);
                });
                if(operationCurrencyExchangesWithExchangeRate.length > 0){
                    return true;
                }
            }
            return false;
        },
        oneOfOtherHasExchangeRate:function (){
            if(this.operationPaymentCorrections.length > 0){
               let operationPaymentCorrectionsWithExchangeRate =  this.operationPaymentCorrections.filter(flow_connection => {
                  return flow_connection.exchange_rate != null || flow_connection.source_amount != flow_connection.target_amount;
                });
               if(operationPaymentCorrectionsWithExchangeRate.length > 0){
                   return true;
               }
            }
            if(this.operationCurrencyExchanges.length > 0){
                let operationCurrencyExchangesWithExchangeRate =  this.operationCurrencyExchanges.filter(flow_connection => {
                    return flow_connection.exchange_rate != null || flow_connection.source_amount != flow_connection.target_amount;
                });
                if(operationCurrencyExchangesWithExchangeRate.length > 0){
                    return true;
                }
            }
            return false;
        },
        contractorHasOtherTransfer(contractorId){
            let contractorTransfer = this.operationContractorTransfers.filter(item=>{
                return item.contractor_id == contractorId && item.hasOwnProperty('allocation') && item.allocation.target_type !== 'App\\UnallocatedPayment';
            })

            return contractorTransfer.length > 0;
        },
        hideModal: function () {
            const self = this;
            if(this.isDepartmentTransfer){

                $.ajax({
                    url: '/destroy-lock',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    method: 'POST',
                    data: {
                        source_id: self.operation.id,
                        type: 'App\\Operation'
                    },
                }).then(function(){
                    self.$emit('hideModal')
                });
            }
            else{
                this.$emit('hideModal')
            }


        },
        showAdditionalHeadersInDocuments :function (){
            this.showAdditionalHeaders = true;
        },
        fetchClearOperationContractorTransfers:function(){
            const self = this;
            const preparedTransfers = [];
            this.clearOperationContractorTransfers = [];
            const contractor_ids = [];
            this.getContractorTransfers().forEach(resource => {
                if(resource.target !== undefined){
                    if(!contractor_ids.includes(resource.target.contractor_id)){
                        contractor_ids.push(resource.target.contractor_id)
                        preparedTransfers.push({
                            checked: self.money.toFloat(resource.target_amount) !== 0 && resource.target_type === 'App\\UnallocatedPayment',
                            disabled: false,
                            id: resource.id,
                            amount: resource.target_type === 'App\\UnallocatedPayment' ? resource.target_amount_money : '0,00',
                            local_balance: resource.target_type === 'App\\UnallocatedPayment' ? resource.target_amount_money : '0,00',
                            last_value: resource.target_type === 'App\\UnallocatedPayment' ? resource.target_amount_money : '0,00',
                            contractor_id: resource.target.contractor_id,
                            currency: resource.source.currency,
                            exchange_rate: resource.exchange_rate,
                            exchanged_amount: '0,00',
                            exchange_target_currency: this.operation.currency,
                            allocation_id: resource.id,
                            operation_id: resource.source.id,
                            operation: resource.source,
                            allocation: resource,
                            target_type:  resource.target_type,
                            unique: resource.id
                        })
                    }
                }
                else{
                    preparedTransfers.push(resource)
                }

            });
            if(this.getContractorTransfers().length === 0 ||(preparedTransfers.length > 0 && preparedTransfers[preparedTransfers.length - 1].checked)){
                let blankContactorTransfer = {...this.blankContractorTransfer};
                blankContactorTransfer.unique = Date.now();
                preparedTransfers.push(blankContactorTransfer)
            }
            this.clearOperationContractorTransfers = preparedTransfers;
            return preparedTransfers;
        },
        operationTransfersDocumentsForContractor: function (collection, contractorId){
            if(collection !== undefined && collection.length > 0){
                return collection.filter(document=>{
                    return document.contractor_id == contractorId
                })
            }
           return [];
        },
        getTransferPaymentCorrectionsForContractor: function(flow_connections, contractorId){
            if(flow_connections !== undefined && flow_connections.length > 0 ){
                return flow_connections.filter(flow_connection => {
                    return flow_connection.target.contractor_id == contractorId
                })
            }
               return [];

        },
        getTransferCurrencyExchangesForContractor:function(flow_connections, contractorId){
            if(flow_connections !== undefined && flow_connections.length > 0 ){
                return flow_connections.filter(flow_connection => {
                    return flow_connection.target.contractor_id == contractorId
                })
            }
            return [];
        },
        rowHasError: function(index, type, extra = false) {
            let validated = ['amount', 'exchanged_amount'];
            if(extra){
                validated.push('name_of_service', 'document_number')
            }
            for(let i = 0; i < validated.length; i++) {
                var field = 'operation_modal_content.' +type+'.'+index+'.' + validated[i]
                if(this.errors !== undefined){
                    if(field in this.errors){
                        return true;
                    }
                }

            }
            return false;
        },
        getErrorMessage: function(index, type, extra =false) {
            if(this.rowHasError(index, type, extra)){
                var amount = 'operation_modal_content.' +type+'.'+index+'.' + 'amount';
                var exchanged_amount = 'operation_modal_content.' +type+'.'+index+'.' + 'exchanged_amount';
                var document_number = 'operation_modal_content.' +type+'.'+index+'.' + 'document_number';
                var name_of_service = 'operation_modal_content.' +type+'.'+index+'.' + 'name_of_service';
                return [amount in this.errors ? this.errors[amount][0] : '', exchanged_amount in this.errors ? this.errors[exchanged_amount][0] : '', document_number in this.errors ? this.errors[document_number][0] : '', name_of_service in this.errors ? this.errors[name_of_service][0] : '']
            }
            return ''
        },
        getOperationAllocatedDocuments: function (document) {
                if(this.modalContext.documentPayments!== undefined){
                    return this.modalContext.documentPayments.filter(allocation => {
                        return allocation.operation_id === this.getOperationParentOrSelf(this.operation).id && allocation.allocation_id === document.document_id
                    });
                }
                return [];

        },
        isDocumentAllocatedForOperation: function (document) {
            return this.getOperationAllocatedDocuments(document).length > 0;
        },
        getFirstAllocationAmount: function (document) {
            return this.isDocumentAllocatedForOperation(document) ? this.getOperationAllocatedDocuments(document)[0].amount : 0;
        },
        getFirstAllocationExchangedAmount: function (document) {
            return this.isDocumentAllocatedForOperation(document) ? this.getOperationAllocatedDocuments(document)[0].exchanged_amount : 0;
        },
        getFirstAllocationExchangeRate: function (document) {
            return this.isDocumentAllocatedForOperation(document) ? (this.getOperationAllocatedDocuments(document)[0].exchange_rate !== null ? this.getOperationAllocatedDocuments(document)[0].exchange_rate : 1) : document.exchange_rate;
        },
        getAllocatedOperationDepartments: function (department) {
            let context = this;
            if(this.modalContext.departmentTransfers !== undefined){
                return this.modalContext.departmentTransfers.filter(flow_connection => {
                    return flow_connection.source_type === 'App\\Operation' && flow_connection.source_id === context.operation.id && flow_connection.target.department_id === department.id
                });
            }
            return [];

        },
        isOperationAllocatedForDepartment: function (department) {
            return this.getAllocatedOperationDepartments(department).length > 0;
        },
        isAllocationAllocated: function (department) {
            return this.getAllocatedOperationDepartments(department).length > 0;
        },
        getFirstDepartmentAmount: function (department) {
            return this.isOperationAllocatedForDepartment(department) ? this.getAllocatedOperationDepartments(department)[0].amount : 0;
        },
        getAllocatedOperationCategories: function (category) {
            let context = this;
            if(this.modalContext.categoryAllocations !== undefined){
              return this.modalContext.categoryAllocations.filter(flow_connection => {
                return flow_connection.target_type === 'App\\CostAndIncom' && flow_connection.source_id === context.operation.id && flow_connection.target.payment_source_category_id=== category.id
              });
            }
          return [];
        },
        getContractorTransfers: function () {
            let context = this;
            return ![null, undefined, ''].includes(this.modalContext.contractorTransfers) ? this.modalContext.contractorTransfers.filter(flow_connection => {
                return flow_connection.source_type === 'App\\Operation' && flow_connection.source_id === context.operation.id
            }) : [];
        },
        getSourceTransfers: function () {
            let context = this;
            return ![null, undefined, ''].includes(this.modalContext.sourceTransfers) ? this.modalContext.sourceTransfers.filter(flow_connection => {
                return flow_connection.source_type === 'App\\Operation' && flow_connection.source_id === context.operation.id
            }) : [];
        },
        getDocumentsPayments: function () {
            let context = this;
            return ![null, undefined, ''].includes(this.modalContext.collectiveDocumentPayments) ? this.modalContext.collectiveDocumentPayments.filter(allocation => {
                return allocation.allocation_type === 'App\\Operation' && allocation.operation_id === context.operation.id
            }) : [];
        },
        isOtherPaymentCollection: function (paymentCorrectionsCollection) {
            return ![null, undefined, ''].includes(paymentCorrectionsCollection);
        },
        isOperationForOtherPayment: function (forOperation) {
            return ![null, undefined, ''].includes(forOperation);
        },
        isOperationForOtherPaymentNotRootOperation: function (forOperation) {
            return ![null, undefined, ''].includes(forOperation.source.payment_source) &&
                (forOperation.source.payment_source.payment_type_name === 'department_transfers' || forOperation.source.payment_source.payment_type_name === 'contractor_transfers');
        },
        isOtherPaymentForOperation: function (allocation, forOperation, relationName) {
            if (relationName === 'operation') {
                return allocation.source_id === forOperation.source_id;
            } else {
                return allocation.source_id === forOperation.source_id;
            }
        },
        isAllocationAndOtherPaymentContractorEqual: function (allocation, forOperation, relationName) {
            if (relationName === 'operation') {
                return allocation.source.contractor_id === forOperation.source.contractor_id;
            } else {
                return allocation.source.contractor_id === forOperation.source.contractor_id;
            }
        },
        getOtherPayments: function (paymentCorrectionsCollection, forOperation, relationName) {
            let self = this;
            return self.isOtherPaymentCollection(paymentCorrectionsCollection) && self.isOperationForOtherPayment(forOperation) ? paymentCorrectionsCollection.filter(allocation => {
                if (self.isOperationForOtherPaymentNotRootOperation(forOperation)) {
                    return self.isOtherPaymentForOperation(allocation, self.getOperationParentOrSelf(forOperation), relationName) &&
                        self.isAllocationAndOtherPaymentContractorEqual(allocation, forOperation, relationName);
                } else {
                    return self.isOtherPaymentForOperation(allocation, forOperation, relationName) &&
                        self.isAllocationAndOtherPaymentContractorEqual(allocation, forOperation, relationName);
                }
            }) : [];
        },
        getCorrections: function (paymentCorrectionsCollection, forOperation) {
            return this.getOtherPayments(paymentCorrectionsCollection, forOperation, 'operation');
        },
        getOperationPaymentCorrections: function () {
            // return this.getCorrections(this.modalContext.payment_corrections, this.operation)
           return  isSet(this.modalContext.payment_corrections) ? this.modalContext.payment_corrections : [];
        },
        hasPaymentCorrections: function () {
            return this.operationPaymentCorrections.length > 0;
        },
        getTransfersPaymentsCorrections: function () {
            return isSet(this.modalContext.transfer_payment_corrections) ? this.modalContext.transfer_payment_corrections : [];
        },
        getTransfersPaymentsCorrectionsOffsets: function () {
            return isSet(this.modalContext.transfer_payment_corrections_offsets) ? this.modalContext.transfer_payment_corrections_offsets : [];
        },
        getTransfersCurrencyExchanges: function () {
            return isSet(this.modalContext.transfer_currency_exchanges) ? this.modalContext.transfer_currency_exchanges : [];
        },
        getTransfersCurrencyExchangesOffsets: function () {
            return isSet(this.modalContext.transfer_currency_exchanges_offsets) ? this.modalContext.transfer_currency_exchanges_offsets : [];
        },
        hasTransfersPaymentsCorrections: function () {
            return this.operationContractorTransfersCorrections.length > 0;
        },
        hasTransfersPaymentsCorrectionsOffsets: function () {
            return this.operationContractorTransfersCorrectionsOffsets.length > 0;
        },
        hasTransfersCurrencyExchanges: function () {
            return this.operationContractorTransfersCurrencyExchanges.length > 0;
        },
        hasTransfersCurrencyExchangesOffsets: function () {
            return this.operationContractorTransfersCurrencyExchangesOffsets.length > 0;
        },
        getTransferPaymentCorrections: function (contractorTransfer) {
            return this.getCorrections(this.operationContractorTransfersCorrections, contractorTransfer.allocation)
        },
        hasGenerateBalance: function () {
            return this.operationGeneratedBalance.length > 0;
        },
        getCorrectionsOffsets: function (paymentCorrectionsCollection, forOperation) {
            return this.getOtherPayments(paymentCorrectionsCollection, forOperation, 'allocation');
        },
        getOperationPaymentCorrectionsOffsets: function () {
            return this.getCorrectionsOffsets(this.modalContext.payment_corrections_offsets, this.operation);
        },
        hasPaymentCorrectionsOffsets: function () {
            return this.operationPaymentCorrectionsOffsets.length > 0;
        },
        getTransferPaymentCorrectionsOffsets: function (contractorTransfer) {
            return this.getCorrectionsOffsets(this.operationContractorTransfersCorrectionsOffsets, contractorTransfer.allocation);
        },
        getOperationCurrencyExchanges: function () {
            return isSet(this.modalContext.currency_exchanges) ? this.modalContext.currency_exchanges : []
            // return this.getCorrections(this.modalContext.currency_exchanges, this.operation)
        },
        getTransferCurrencyExchanges: function (contractorTransfer) {
            return this.getCorrections(this.operationContractorTransfersCurrencyExchanges, contractorTransfer.allocation);
        },
        hasCurrencyExchanges: function () {
            return this.operationCurrencyExchanges.length > 0;
        },
        getOperationCurrencyExchangesOffsets: function () {
            return this.getCorrectionsOffsets(this.modalContext.currency_exchanges_offsets, this.operation);
        },
        getTransferCurrencyExchangesOffsets: function (contractorTransfer) {
            return this.getCorrectionsOffsets(this.operationContractorTransfersCurrencyExchangesOffsets, contractorTransfer.allocation);
        },
        getCorrectionAmount: function (correction) {
            return this.money.toFloat(correction.source_amount)
        },
        getCorrectionOffsetAmount: function (correction) {
            let exchangedAmount = correction.exchange_rate !== null ? correction.exchange_rate : 1;

            return Math.abs(exchangedAmount) * (this.money.toFloat(correction.target_amount_money) < 0 ? -1 : 1)
        },
        getUnallocatedPayments: function () {
            let context = this;
            return ![null, undefined, ''].includes(this.modalContext.unallocated_payments) ? this.modalContext.unallocated_payments.filter(allocation => {
                return allocation.operation_id === context.operation.id
            }) : [];
        },
        getOperationDocuments: function () {
            const _this = this;
            let operationDocuments = this.method === 'show' ? this.modalContext.allocatableDocuments.filter(function(item){
               return _this.modalContext.documentPayments.map(obj => obj.target_id).includes(item.document_id)
            }) : this.modalContext.allocatableDocuments
            if (!['', null, undefined].includes(operationDocuments)) {
                operationDocuments = operationDocuments.filter(document => {
                    return !document.draft;
                }).sort(function (a, b) {
                    if (a.date_issued === b.date_issued) {
                        // Jeśli daty są równe, sortuj po ID rosnąco
                        return a.id - b.id;
                    }
                    // Sortuj po dacie rosnąco
                    return (a.date_issued >= b.date_issued) ? 1 : -1;
                });
                operationDocuments.forEach(document => {
                    document.allocation.amount = this.getFirstAllocationAmount(document);
                    document.allocation.exchange_rate = this.getFirstAllocationExchangeRate(document);
                    document.allocation.exchanged_amount = this.getFirstAllocationExchangedAmount(document);
                })
                return operationDocuments;
            } else {
                return [];
            }
        },
        getOperationProformas: function () {
            const _this = this;
            let operationDocuments = this.method === 'show' ? this.modalContext.proformas.filter(function(item){
                return _this.modalContext.documentPayments.map(obj => obj.target_id).includes(item.document_id)
            }) : this.modalContext.proformas
            if (!['', null, undefined].includes(operationDocuments)) {
                operationDocuments = operationDocuments.filter(document => {
                    return !document.draft;
                }).sort(function (a, b) {
                    if (a.date_issued === b.date_issued) {
                        // Jeśli daty są równe, sortuj po ID rosnąco
                        return a.id - b.id;
                    }
                    // Sortuj po dacie rosnąco
                    return (a.date_issued >= b.date_issued) ? 1 : -1;
                });
                operationDocuments.forEach(document => {
                    document.allocation.amount = this.getFirstAllocationAmount(document);
                    document.allocation.exchange_rate = this.getFirstAllocationExchangeRate(document);
                    document.allocation.exchanged_amount = this.getFirstAllocationExchangedAmount(document);
                })
                return operationDocuments;
            } else {
                return [];
            }
        },
        getAllocatedAmountForTransferDocument: function (transferDocument) {

            return this.operationContractorTransfers.filter(allocation => {
                return allocation.allocation.target_id === transferDocument.document_id && allocation.allocation.target_type === 'App\\Document'
            }).reduce((sum, document) => {
                return sum + this.money.toFloat(document.allocation.target_amount_money);
            }, 0);
        },
        hasCurrencyExchangesOffsets: function () {
            return this.operationCurrencyExchangesOffsets.length > 0;
        },
        getFirstSourceTransferAmount: function () {
            return this.isSourceTransfers() ? this.getSourceTransfers()[0].amount : 0;
        },
        getFirstSourceTransferId: function () {
            return this.isSourceTransfers() ? this.getSourceTransfers()[0].id : 0;
        },
        getFirstDocumentsPaymentsAmount: function () {
            return this.isDocumentsPayments() ? this.getDocumentsPayments()[0].amount : 0;
        },
        getFirstDocumentsPaymentsId: function () {
            return this.isDocumentsPayments() ? this.getDocumentsPayments()[0].id : 0;
        },
        isSourceTransfers: function () {
            return this.getSourceTransfers().length > 0;
        },
        isDocumentsPayments: function () {
            return this.getDocumentsPayments().length > 0;
        },
        isContractorTransfers: function () {
            return this.getContractorTransfers().length > 0;
        },
        isUnallocatedPayment: function () {
            return this.getUnallocatedPayments().length > 0;
        },
        isOperationAllocatedForCategory: function (category) {
            return this.getAllocatedOperationCategories(category).length > 0;
        },
        hasCorrection: function () {
            return this.hasPaymentCorrections() || this.hasPaymentCorrectionsOffsets() || this.hasCurrencyExchanges()
                || this.hasCurrencyExchangesOffsets();
        },
        getFirstCategoryAmount: function (category) {
            return this.isOperationAllocatedForCategory(category) ? this.getAllocatedOperationCategories(category)[0].target_amount : 0;
        },
        getFirstCategoryExchangeRate: function (category) {
            return this.isOperationAllocatedForCategory(category) ? this.getAllocatedOperationCategories(category)[0].exchange_rate : 0;
        },
        getFirstUnallocatedPaymentLocalBalance: function () {
            return this.isUnallocatedPayment() ? this.getUnallocatedPayments()[0].allocation.local_balance : 0;
        },
        getFirstCategoryLocalAmount: function (category) {
            return this.isOperationAllocatedForCategory(category) ? this.getAllocatedOperationCategories(category)[0].local_amount : 0;
        },
        getOperationParentOrSelf: function (operation) {
            return this.$store.getters.getOperationParentOrSelf(operation)
        },
        getOperationRootOrSelf: function (operation) {
            return this.$store.getters.getOperationRootOrSelf(operation)
        },
        paymentTransferredToDepartmentName: function (department) {
            return $.i18n._('payment_transferred_to_department') + ' ' + department.name;
        },
        handleContractorTransferChecked: function (index, balance, contractor_id, clearOperationContractorTransfers) {
            this.clearUncheckCategories(null);
            this.clearSourceTransfer();
            const _this = this;
            var indexOfAllocatedAmount =  this.allocatedAmounts.contractorTransfers.findIndex(function(item){
                return _this.money.toFloat(item) ==  _this.money.toFloat(clearOperationContractorTransfers.last_value)
            })

            if (index == (this.clearOperationContractorTransfers.length - 1) && this.operationContractorTransfers[index].checked) {
                let blankContactorTransfer = {...this.blankContractorTransfer};
                blankContactorTransfer.unique = Date.now();
                this.operationContractorTransfers.push(blankContactorTransfer);
                this.clearOperationContractorTransfers.push(blankContactorTransfer)
                this.clearOperationContractorTransfers[index].checked = true;
                // shallow copy of blankContractorTransfer
            } else if (!this.operationContractorTransfers[index].checked) {
                this.clearOperationContractorTransfers[index].checked = false;
                this.operationContractorTransfers[index].amount = '0,00';
                this.operationContractorTransfers[index].local_balance = '0,00';
                this.clearOperationContractorTransfers[index].amount = '0,00';
                this.clearOperationContractorTransfers[index].local_balance = '0,00';
                this.clearOperationContractorTransfers[index].last_value = '0,00'
                this.allocatedAmounts.contractorTransfers[indexOfAllocatedAmount] = 0;
                this.allocatedAmounts.contractorTransfers.splice(indexOfAllocatedAmount, 1)



                if(index >= 0 && !this.contractorHasOtherTransfer(contractor_id)){

                    this.clearOperationContractorTransfers.splice(index, 1)
                    this.operationContractorTransfers.splice(index, 1);
                }
                if(this.clearOperationContractorTransfers.length == 0){
                    let blankContactorTransfer = {...this.blankContractorTransfer};
                    blankContactorTransfer.unique = Date.now();
                    this.operationContractorTransfers.push(blankContactorTransfer);
                    this.clearOperationContractorTransfers.push(blankContactorTransfer)
                }
            }

            this.calculateTotalAllocated();
            this.calculateLeftForSplit();
            this.handleSingleSelectCheckboxes();
        },
        validateSign: function (value) {
            let valueFloat = this.money.toFloat(value);
            const amount = this.money.toFloat(this.operation.formatted_amount);
            const mod = (valueFloat > 0 && amount < 0) || (valueFloat < 0 && amount > 0) ? -1 : 1;
            return valueFloat * mod
        },
        handleDocumentAllocationChanged: function (data) {
            this.allocatedAmounts.documentAllocations[data.index] = this.money.toFloat(data.allocation.amount);
            this.operationDocuments[data.index].allocation = data.allocation;
            let checkedDocuments = this.operationDocuments.filter(document => {
                return document.allocation.checked && this.money.toFloat(document.allocation.amount) === 0;
            })
            this.isFilled = checkedDocuments.length === 0;
            this.calculateTotalAllocated();
            this.calculateLeftForSplit();
            this.handleSingleSelectCheckboxes();
        },
        handleDocumentProformaAllocationChanged: function (data) {
            this.allocatedAmounts.proformaAllocations[data.index] = this.money.toFloat(data.allocation.amount);
            this.operationProformas[data.index].allocation = data.allocation;
            let checkedDocuments = this.operationProformas.filter(document => {
                return document.allocation.checked && this.money.toFloat(document.allocation.amount) === 0;
            })
            this.isFilled = checkedDocuments.length === 0;
            this.calculateTotalAllocated();
            this.calculateLeftForSplit();
            this.handleSingleSelectCheckboxes();
        },

        handleTransferDocumentAllocationChanged: function (data) {
            this.contractorTransfersAllocatedAmounts[data.contractor_id].contractorTransfersDocuments[data.index] = this.money.toFloat(data.allocation.amount);
            this.calculateTotalAllocated();
            this.calculateLeftForSplit();
        },
        handleDepartmentAmountChanged: function (index) {
            this.operationDepartments[index].amount = this.validateSign(this.operationDepartments[index].amount);
            if (Math.abs(this.money.toFloat(this.operationDepartments[index].amount)) > Math.abs((this.money.toFloat(this.leftForSplit) + this.allocatedAmounts.departments[index]))) {
                this.operationDepartments[index].amount = this.money.localize(this.money.toFloat(this.leftForSplit) + this.allocatedAmounts.departments[index]);
            } else {
                this.operationDepartments[index].amount = this.money.localize(this.money.toFloat(this.operationDepartments[index].amount));
            }
            this.allocatedAmounts.departments[index] = this.money.toFloat(this.operationDepartments[index].amount);

            this.calculateTotalAllocated();
            this.calculateLeftForSplit();
        },
      handleNewDocumentAmountChanged: function () {
        this.newDocumentForOperation.amount = this.validateSign(this.newDocumentForOperation.amount);
        if (Math.abs(this.money.toFloat(this.newDocumentForOperation.amount)) > Math.abs((this.money.toFloat(this.leftForSplit) + this.allocatedAmounts.newDocumentForOperation[0]))) {
          this.newDocumentForOperation.amount = this.money.localize(this.money.toFloat(this.leftForSplit) + this.allocatedAmounts.newDocumentForOperation[0]);
        } else {
          this.newDocumentForOperation.amount = this.money.localize(this.money.toFloat(this.newDocumentForOperation.amount) );
        }
        // this.allocatedAmounts.newDocumentForOperation = this.money.toFloat(this.newDocumentForOperation.amount);
        this.allocatedAmounts.newDocumentForOperation[0] = this.money.toFloat(this.newDocumentForOperation.amount);
        this.calculateTotalAllocated();
        this.calculateLeftForSplit();
      },
        handleContractorTransferSelectChanged: function (index, unique) {
            let indexOfOperationContractorTransfer = this.operationContractorTransfers.findIndex((item)=>{
                return item.hasOwnProperty('unique') && item.unique == unique
            });
            if (parseFloat(this.clearOperationContractorTransfers[index].contractor_id) === 0 && index < this.clearOperationContractorTransfers.length - 1) {
                this.operationContractorTransfers[indexOfOperationContractorTransfer].to_delete = true;
                this.operationContractorTransfers[indexOfOperationContractorTransfer].amount = '0,00';
            }
            if(parseFloat(this.clearOperationContractorTransfers[index].contractor_id) !== 0){
                this.operationContractorTransfers[indexOfOperationContractorTransfer].contractor_id = this.clearOperationContractorTransfers[index].contractor_id
            }

        },
        handleContractorTransferAmountChanged: function (index, balance, contractor_id, clearOperationContractorTransfers) {
            const _this = this;

            var indexOfAllocatedAmount =  this.allocatedAmounts.contractorTransfers.findIndex(function(item){
                return _this.money.toFloat(item) ==  _this.money.toFloat(clearOperationContractorTransfers.last_value)
            })

            if(indexOfAllocatedAmount < 0){
                indexOfAllocatedAmount = index;
            }

            let indexOfOperationContractorTransfer = this.operationContractorTransfers.findIndex((item) => {
                return item.contractor_id == contractor_id && (!item.hasOwnProperty('target_type') || item.hasOwnProperty('target_type') && item.target_type == 'App\\UnallocatedPayment')
            });
            const leftForSplit = this.leftForSplit;

            const maxToAllocate = Math.abs(this.money.toFloat(leftForSplit)) + Math.abs(this.money.toFloat(this.clearOperationContractorTransfers[index].amount))
            if (Math.abs(this.money.toFloat(this.clearOperationContractorTransfers[index].local_balance)) > maxToAllocate) {
                this.clearOperationContractorTransfers[index].local_balance = this.money.localize(this.validateSign(maxToAllocate));
                this.clearOperationContractorTransfers[index].amount = this.money.localize(this.validateSign(maxToAllocate));
                this.operationContractorTransfers[indexOfOperationContractorTransfer].local_balance = this.validateSign(maxToAllocate);
                this.operationContractorTransfers[indexOfOperationContractorTransfer].amount = this.validateSign(maxToAllocate);
                this.clearOperationContractorTransfers[index].local_balance = this.money.localize(this.money.toFloat(this.validateSign(maxToAllocate)));
                this.clearOperationContractorTransfers[index].amount = this.money.localize(this.money.toFloat(this.validateSign(maxToAllocate)));
                this.clearOperationContractorTransfers[index].last_value = this.money.localize(this.money.toFloat(this.validateSign(maxToAllocate)));
            } else {
                this.clearOperationContractorTransfers[index].local_balance = this.money.localize(this.money.toFloat(this.validateSign(this.clearOperationContractorTransfers[index].local_balance)));
                this.clearOperationContractorTransfers[index].amount = this.money.localize(this.money.toFloat(this.validateSign(this.clearOperationContractorTransfers[index].local_balance)));
                this.operationContractorTransfers[indexOfOperationContractorTransfer].local_balance = this.validateSign(this.clearOperationContractorTransfers[index].local_balance);
                this.operationContractorTransfers[indexOfOperationContractorTransfer].amount = this.validateSign(this.clearOperationContractorTransfers[index].amount);
                this.clearOperationContractorTransfers[index].local_balance = this.money.localize(this.money.toFloat(this.validateSign(this.clearOperationContractorTransfers[index].local_balance)));
                this.clearOperationContractorTransfers[index].amount = this.money.localize(this.money.toFloat(this.validateSign(this.clearOperationContractorTransfers[index].local_balance)));
                this.clearOperationContractorTransfers[index].last_value = this.money.localize(this.money.toFloat(this.validateSign(this.clearOperationContractorTransfers[index].local_balance)));
            }
            this.allocatedAmounts.contractorTransfers[indexOfAllocatedAmount] = this.money.toFloat(this.clearOperationContractorTransfers[index].local_balance);
           this.calculateTotalAllocated();
            this.calculateLeftForSplit();
            this.updateStateToCommitAllocations()
        },
        handleOperationDeleted: function () {
            const self = this;
            this.operationPaymentCorrections.forEach((correction, index) => {
                self.handlePaymentCorrectionDelete(index)
            })
            this.operationContractorTransfersCorrections.forEach((correction, index) => {
                self.handleTransferPaymentCorrectionDelete(correction, index)
            })
            this.operationPaymentCorrectionsOffsets.forEach((correction, index) => {
                self.handlePaymentCorrectionOffsetDelete(index)
            })
            this.operationContractorTransfersCorrectionsOffsets.forEach((correction, index) => {
                self.handleTransferPaymentCorrectionOffsetDelete(correction, index)
            })
            this.operationCurrencyExchanges.forEach((correction, index) => {
                self.handleCurrencyExchangeDelete(index)
            })
            this.operationContractorTransfersCurrencyExchanges.forEach((correction, index) => {
                self.handleTransferCurrencyExchangeDelete(correction, index)
            })
            this.operationCurrencyExchangesOffsets.forEach((correction, index) => {
                self.handleCurrencyExchangeOffsetDelete(index)
            })
            this.operationContractorTransfersCurrencyExchangesOffsets.forEach((correction, index) => {
                self.handleTransferCurrencyExchangeDelete(correction, index)
            })
            for (const property in this.operationGeneratedBalance) {
                if(this.operationGeneratedBalance[property].id !== undefined){
                    this.handleGeneratedBalanceDelete(this.operationGeneratedBalance[property].amount);
                }
            }
        },
        handleTransferDocumentDelete: function (amount, operationContractorTransfer, transferDocument, contractorTransferIndex, index, contractor_id) {
            const self = this;
            index = this.operationTransfersDocuments[operationContractorTransfer.operation_id].findIndex(function(allocated){
                return allocated.flow_connection_id == transferDocument.flow_connection_id
            });
            let indexOfOperationContractorTransfer = this.operationContractorTransfers.findIndex((item) => {
                return item.contractor_id == contractor_id && item.hasOwnProperty('allocation_id') && item.allocation_id == transferDocument.flow_connection_id
            })
            this.operationTransfersDocuments[operationContractorTransfer.operation_id].splice(index, 1);
            this.operationContractorTransfers.splice(indexOfOperationContractorTransfer, 1)
            let indexOfAmount = this.allocatedAmounts.contractorTransfers.findIndex(function(allocated){
                return self.money.toFloat(allocated) == self.money.toFloat(amount)
            });
            this.allocatedAmounts.contractorTransfers[indexOfAmount] = 0;
            this.allocatedAmounts.contractorTransfers.splice(indexOfAmount, 1);
            if (transferDocument.flow_connection_id > 0) {
                this.stateToCommit.transferDocumentsForDelete.push(transferDocument.flow_connection_id)
            }
            this.checkDestroyContractorSection(contractor_id);
            this.updateStateToCommitAllocations()
            this.calculateTotalAllocated();
            this.calculateLeftForSplit();
        },
        updateStateToCommitAllocations: function () {
            this.$store.commit(mutations.SET_STATE_TO_COMMIT_ALLOCATIONS, {
                index: this.operationIndex,
                group_name: this.groupName,
                operation_id: this.operation.id,
                state: {...this.stateToCommit},
            });
        },
        updateStateLeftForSplit: function () {
            if(this.modalVisible){
                this.$store.commit(mutations.SET_STATE_LEFT_FOR_SPLIT, {
                    index: this.operationIndex,
                    group_name: this.groupName,
                    left_for_split: this.money.toFloat(this.leftForSplit)
                });
            }

        },
        handlePaymentCorrectionDelete: function (index, triggerEvent = true) {
            this.allocatedAmounts.paymentCorrections[index] = 0;
            this.calculateTotalAllocated();
            this.calculateLeftForSplit();

            if (triggerEvent) {
                if (!['', undefined, null].includes(this.operationPaymentCorrections[index]) &&
                    this.stateToCommit.correctionsForDelete.indexOf(this.operationPaymentCorrections[index].id) < 0) {
                    this.stateToCommit.correctionsForDelete.push(this.operationPaymentCorrections[index].id)
                }
                events.$emit('paymentCorrectionDeleted', {
                    allocationId: this.operationPaymentCorrections[index].id
                })
            } else {
                this.updateStateToCommitAllocations();
                this.updateStateLeftForSplit();
            }
            this.operationPaymentCorrections.splice(index, 1);
        },
        handleTransferPaymentCorrectionDelete: function (correction, contractorIndex, triggerEvent = true, contractor_id = null) {
            let contractorTransfer = this.operationContractorTransfers[contractorIndex];
            const self = this;
            if (isSet(contractorTransfer)) {
                let index = this.getTransferPaymentCorrections(contractorTransfer).indexOf(correction);

                this.contractorTransfersAllocatedAmounts[contractorTransfer.contractor_id].contractorTransfersPaymentCorrections.splice(index, 1);
                index = this.allocatedAmounts.contractorTransfers.findIndex(function(allocated){
                    return allocated == self.money.toFloat(correction.source_amount)
                });
                this.allocatedAmounts.contractorTransfers[index] = 0;
                this.allocatedAmounts.contractorTransfers.splice(index, 1);
                this.operationContractorTransfers[contractorIndex].local_balance = this.money.localize(this.money.toFloat(this.operationContractorTransfers[contractorIndex].local_balance)
                    + this.money.toFloat(this.getCorrectionAmount(correction)));
                this.calculateTotalAllocated();
                this.calculateLeftForSplit();
                if (triggerEvent) {
                    if (!['', undefined, null].includes(correction) &&
                        this.stateToCommit.correctionsForDelete.indexOf(correction.allocation_id) < 0) {
                        this.stateToCommit.correctionsForDelete.push(correction.id)
                    }
                    events.$emit('paymentCorrectionDeleted', {
                        allocationId: correction.allocation_id
                    })
                } else {
                    this.updateStateToCommitAllocations();
                    this.updateStateLeftForSplit();
                }

                if(contractor_id !== null){
                    let indexOfOperationContractorTransfer = this.operationContractorTransfers.findIndex((item) => {
                        return item.contractor_id == contractor_id && item.hasOwnProperty('allocation_id') && item.allocation_id == correction.id
                    })
                    this.operationContractorTransfers.splice(indexOfOperationContractorTransfer, 1)
                    this.checkDestroyContractorSection(contractor_id);
                }
                let transferPaymentCorrectionIndex = this.operationContractorTransfersCorrections.indexOf(correction);
                this.operationContractorTransfersCorrections.splice(transferPaymentCorrectionIndex, 1);
            }
        },
        handlePaymentCorrectionOffsetDelete: function (index, triggerEvent = true) {
            this.allocatedAmounts.paymentCorrectionsOffsets[index] = 0;
            this.calculateTotalAllocated();
            this.calculateLeftForSplit();
            if (triggerEvent) {
                if (!['', undefined, null].includes(this.operationPaymentCorrectionsOffsets[index]) &&
                    this.stateToCommit.correctionsOffsetsForDelete.indexOf(this.operationPaymentCorrectionsOffsets[index].operation_id) < 0) {
                    this.stateToCommit.correctionsOffsetsForDelete.push(this.operationPaymentCorrectionsOffsets[index].operation_id)
                }
                events.$emit('paymentCorrectionOffsetDeleted', {
                    operationId: this.operationPaymentCorrectionsOffsets[index].operation_id
                })
            } else {
                this.updateStateToCommitAllocations();
                this.updateStateLeftForSplit();
            }
            this.operationPaymentCorrectionsOffsets.splice(index, 1);
        },

        handleTransferPaymentCorrectionOffsetDelete: function (correction, contractorIndex, triggerEvent = true) {
            let contractorTransfer = this.operationContractorTransfers[contractorIndex];
            if (isSet(contractorTransfer)) {
                let index = this.getTransferPaymentCorrectionsOffsets(contractorTransfer).indexOf(correction);

                this.contractorTransfersAllocatedAmounts[contractorTransfer.contractor_id].contractorTransfersPaymentCorrectionsOffsets.splice(index, 1);
                this.allocatedAmounts.contractorTransfers[contractorIndex] = this.money.toFloat(this.allocatedAmounts.contractorTransfers[contractorIndex])
                    + this.money.toFloat(this.getCorrectionOffsetAmount(correction));
                this.operationContractorTransfers[contractorIndex].local_balance = this.money.localize(this.money.toFloat(this.operationContractorTransfers[contractorIndex].local_balance)
                    + this.money.toFloat(this.getCorrectionOffsetAmount(correction)));

                if (triggerEvent) {
                    if (!['', undefined, null].includes(correction) &&
                        this.stateToCommit.correctionsForDelete.indexOf(correction.operation_id) < 0) {
                        this.stateToCommit.correctionsForDelete.push(correction.operation_id)
                    }
                    events.$emit('paymentCorrectionOffsetDeleted', {
                        operationId: correction.operation_id
                    })
                } else {
                    this.updateStateToCommitAllocations();
                    this.updateStateLeftForSplit();
                }
                let transferPaymentCorrectionOffsetIndex = this.operationContractorTransfersCorrectionsOffsets.indexOf(correction);
                this.operationContractorTransfersCorrectionsOffsets.splice(transferPaymentCorrectionOffsetIndex, 1);
                this.calculateTotalAllocated();
                this.calculateLeftForSplit();
            }
        },
        handleCurrencyExchangeDelete: function (index, triggerEvent = true) {
            this.allocatedAmounts.currencyExchanges[index] = 0;
            this.calculateTotalAllocated();
            this.calculateLeftForSplit();
            if (triggerEvent) {
                if (!['', undefined, null].includes(this.operationCurrencyExchanges[index]) &&
                    this.stateToCommit.currencyExchangesForDelete.indexOf(this.operationCurrencyExchanges[index].id) < 0) {
                    this.stateToCommit.currencyExchangesForDelete.push(this.operationCurrencyExchanges[index].id)
                }
                events.$emit('currencyExchangeDeleted', {
                    allocationId: this.operationCurrencyExchanges[index].id
                })
            } else {
                this.updateStateToCommitAllocations();
                this.updateStateLeftForSplit();
            }
            this.operationCurrencyExchanges.splice(index, 1);
        },
        handleTransferCurrencyExchangeDelete: function (correction, contractorIndex, triggerEvent = true, contractor_id) {
            const self = this;
            let contractorTransfer = this.operationContractorTransfers[contractorIndex];
            if (isSet(contractorTransfer)) {
                let index = this.getTransfersCurrencyExchanges(contractorTransfer).indexOf(correction);

                this.contractorTransfersAllocatedAmounts[contractorTransfer.contractor_id].contractorTransfersCurrencyExchanges.splice(index, 1);
                index = this.allocatedAmounts.contractorTransfers.findIndex(function(allocated){
                    return allocated == self.money.toFloat(correction.target_amount_money)
                });
                this.allocatedAmounts.contractorTransfers[index] = 0;
                this.allocatedAmounts.contractorTransfers.splice(index, 1);
                this.operationContractorTransfers[contractorIndex].local_balance = this.money.localize(this.money.toFloat(this.operationContractorTransfers[contractorIndex].local_balance)
                    + this.money.toFloat(this.getCorrectionAmount(correction)));
                this.calculateTotalAllocated();
                this.calculateLeftForSplit();
                if (triggerEvent) {
                    if (!['', undefined, null].includes(correction) &&
                        this.stateToCommit.correctionsForDelete.indexOf(correction.allocation_id) < 0) {
                        this.stateToCommit.correctionsForDelete.push(correction.id)
                    }
                    events.$emit('currencyExchangeDeleted', {
                        allocationId: correction.id
                    })
                } else {
                    this.updateStateToCommitAllocations();
                    this.updateStateLeftForSplit();
                }
                if(contractor_id !== null){
                    let indexOfOperationContractorTransfer = this.operationContractorTransfers.findIndex((item) => {
                        return item.contractor_id == contractor_id && item.hasOwnProperty('allocation_id') && item.allocation_id == correction.id
                    })
                    this.operationContractorTransfers.splice(indexOfOperationContractorTransfer, 1)
                    this.checkDestroyContractorSection(contractor_id);
                }
                let transferCurrencyExchangeIndex = this.operationContractorTransfersCurrencyExchanges.indexOf(correction);
                this.operationContractorTransfersCurrencyExchanges.splice(transferCurrencyExchangeIndex, 1);
            }
        },
        handleCurrencyExchangeOffsetDelete: function (index, triggerEvent = true) {
            this.allocatedAmounts.currencyExchangesOffsets[index] = 0;
            this.calculateTotalAllocated();
            this.calculateLeftForSplit();
            if (triggerEvent) {
                if (!['', undefined, null].includes(this.operationCurrencyExchangesOffsets[index]) &&
                    this.stateToCommit.currencyExchangesOffsetForDelete.indexOf(this.operationCurrencyExchangesOffsets[index].operation_id) < 0) {
                    this.stateToCommit.currencyExchangesOffsetForDelete.push(this.operationCurrencyExchangesOffsets[index].operation_id)
                }
                events.$emit('currencyExchangeOffsetDeleted', {
                    operationId: this.operationCurrencyExchangesOffsets[index].operation_id
                })
            } else {
                this.updateStateToCommitAllocations();
                this.updateStateLeftForSplit();
            }
            this.operationCurrencyExchangesOffsets.splice(index, 1);
        },
        handleTransferCurrencyExchangeOffsetDelete: function (correction, contractorIndex, triggerEvent = true) {
            let contractorTransfer = this.operationContractorTransfers[contractorIndex];
            if (isSet(contractorTransfer)) {
                let index = this.getTransfersCurrencyExchangesOffsets(contractorTransfer).indexOf(correction);

                this.contractorTransfersAllocatedAmounts[contractorTransfer.contractor_id].contractorTransfersCurrencyExchangesOffsets.splice(index, 1);
                this.allocatedAmounts.contractorTransfers[contractorIndex] = this.money.toFloat(this.allocatedAmounts.contractorTransfers[contractorIndex])
                    + this.money.toFloat(this.getCorrectionOffsetAmount(correction));
                this.operationContractorTransfers[contractorIndex].local_balance = this.money.localize(this.money.toFloat(this.operationContractorTransfers[contractorIndex].local_balance)
                    + this.money.toFloat(this.getCorrectionOffsetAmount(correction)));
                this.calculateTotalAllocated();
                this.calculateLeftForSplit();
                if (triggerEvent) {
                    if (!['', undefined, null].includes(correction) &&
                        this.stateToCommit.correctionsForDelete.indexOf(correction.operation_id) < 0) {
                        this.stateToCommit.correctionsForDelete.push(correction.operation_id)
                    }
                    events.$emit('currencyExchangeOffsetDeleted', {
                        operationId: correction.operation_id
                    })
                } else {
                    this.updateStateToCommitAllocations();
                    this.updateStateLeftForSplit();
                }
                let transferCurrencyExchangeOffsetIndex = this.operationContractorTransfersCurrencyExchangesOffsets.indexOf(correction);
                this.operationContractorTransfersCurrencyExchangesOffsets.splice(transferCurrencyExchangeOffsetIndex, 1);
            }
        },
        handleGeneratedBalanceDelete: function (id, amount) {

            let index = this.allocatedAmounts.generateBalance.findIndex(item=>{
                return item == this.money.toFloat(amount);
            })

            this.allocatedAmounts.generateBalance[index] = 0

            if(index === 0 && this.operationGeneratedBalance.length === 1){
                this.operationGeneratedBalance = [];
                this.stateToCommit.generatedBalanceForDelete.push({'delete_all':true})
            }
            else{
                this.stateToCommit.generatedBalanceForDelete.push({'id': id})
                let indexToDelete = this.operationGeneratedBalance.findIndex(item=>{
                    return item.id == id;
                })
                this.operationGeneratedBalance.splice(indexToDelete, 1);
            }

            this.calculateTotalAllocated();
            this.calculateLeftForSplit();
            this.updateStateToCommitAllocations();
            this.updateStateLeftForSplit();
        },
        handleTotalAllocatedRequest: function (data) {
            this.allocatedAmounts.documentAllocations[data.index] = this.money.toFloat(data.amount);
            this.calculateTotalAllocated();
            events.$emit('totalAllocatedChanged', {
                totalAllocated: this.totalAllocated
            });
        },
        handleTotalAllocatedProformaRequest: function (data) {
            this.allocatedAmounts.proformaAllocations[data.index] = this.money.toFloat(data.amount);
            this.calculateTotalAllocated();
            events.$emit('totalAllocatedChanged', {
                totalAllocated: this.totalAllocated
            });
        },
        handleDynamicChangeDocumentBalance(data) {
            this.dynamicDocumentsBalance[data.documentId] = data.balanceAfterAllocation;
        },
        deleteAllOtherPayments: function () {
            const self = this;
            this.operationPaymentCorrections.forEach((offset, index) => {
                self.handlePaymentCorrectionDelete(index);
            });
            this.operationPaymentCorrectionsOffsets.forEach((offset, index) => {
                self.handlePaymentCorrectionOffsetDelete(index);
            });
            this.operationCurrencyExchanges.forEach((offset, index) => {
                self.handleCurrencyExchangeDelete(index);
            });
            this.operationCurrencyExchangesOffsets.forEach((offset, index) => {
                self.handleCurrencyExchangeOffsetDelete(index);
            });
        },
        updateStateToCommit: function (stateKey, allocation) {
            if (!allocation instanceof Allocation) throw new Error('allocation needs to be an instance of Allocation (resources/js/helpers/allocation.js)');

            if (!this.stateToCommit.hasOwnProperty(stateKey)) {
                console.log('Unknown state to save: ' + stateKey);
                return;
            }
            let index = this.stateToCommit[stateKey].findIndex((element, index) => {
                return element.allocation_id == allocation.allocation_id;
            });
            if (index >= 0) this.stateToCommit[stateKey][index] = allocation;
            if (0 > index) this.stateToCommit[stateKey].push(allocation);
        },
        getModalCheckboxes: function () {
            return this.$store.getters.getModalCheckboxes(this.operation.id);
        },
        isAnyDocumentChecked: function () {
            let checkedDocuments = this.operationDocuments.filter(document => {
                return document.allocation.checked;
            })
            return checkedDocuments.length > 0;
        },
        isAnyProformaChecked: function () {
            let checkedDocuments = this.operationProformas.filter(document => {
                return document.allocation.checked;
            })
            return checkedDocuments.length > 0;
        },
        isAnyDepartmentChecked: function () {
            return this.operationDepartments.filter(department => {
                return department.checked;
            }).length > 0;
        },
        isAnyDepartmentDisabled: function () {
            return this.operationDepartments.filter(department => {
                return department.disabled;
            }).length > 0;
        },
        isAnyCategoryChecked: function () {
            return this.operationCategories.filter(category => {
                return category.checked;
            }).length > 0;
        },
        isAnyContractorTransferChecked: function () {
            return this.operationContractorTransfers.filter(transfer => {
                return transfer.checked;
            }).length > 0;
        },
        isAnyNewDocumentForOperationChecked: function () {
            return this.newDocumentForOperation.checked;
        },
        isAnyNotSingleSelectCheckboxChecked: function () {
            return this.isAnyDocumentChecked() || this.isAnyDepartmentChecked() || this.isAnyContractorTransferChecked() || this.isAnyNewDocumentForOperationChecked() || this.isAnyProformaChecked();
        },
        clearOperationSourceTransfer: function () {
            this.operationSourceTransfer.disabled = true;
            this.operationSourceTransfer.checked = false;
            this.operationSourceTransfer.amount = '0,00';
        },
        enableOperationSourceTransfer: function () {
            this.operationSourceTransfer.disabled = false;
        },
        clearOperationCategories: function () {
            this.operationCategories.forEach(category => {
                category.disabled = true;
                category.checked = false;
                category.amount = '0,00';
            })
        },
        enableOperationCategories: function () {
            this.operationCategories.forEach(category => {
                category.disabled = false;
            })
        },
        isAnyNotSingleSelectCheckbox: function () {
            return this.getModalCheckboxes().documents.length > 0 || this.operationDepartments.length > 0 || this.operationContractorTransfers.length > 0 || this.newDocumentForOperation.length > 0;
        },
        handleSingleSelectCheckboxes: function () {
            if (this.isAnyNotSingleSelectCheckboxChecked()) {
                this.clearOperationCategories();
                this.clearOperationSourceTransfer();
            } else if (this.isAnyNotSingleSelectCheckbox()) {
                this.enableOperationCategories();
                this.enableOperationSourceTransfer();
            }
        },
        handleNewDocumentForOperationChanged: function(){
            if(!this.newDocumentForOperation.checked){
                this.newDocumentForOperation.name_of_service = '';
                this.newDocumentForOperation.document_number = '';
                this.newDocumentForOperation.amount = 0;
                this.newDocumentForOperation.formatted_amount = 0
                this.handleNewDocumentAmountChanged()
            }

            this.clearUncheckCategories(null);
            this.clearSourceTransfer();
            this.calculateTotalAllocated();
            this.calculateLeftForSplit();
            this.handleSingleSelectCheckboxes();

        },
        handleDepartmentCheckboxChange: function (index) {
            this.clearUncheckCategories(null);
            this.clearSourceTransfer();
            this.operationDepartments[index].readonly = !this.operationDepartments[index].checked;
            if (!this.operationDepartments[index].checked) {
                this.operationDepartments[index].amount = '0,00';
                this.allocatedAmounts.departments[index] = 0;
            }
            this.calculateTotalAllocated();
            this.calculateLeftForSplit();
            this.handleSingleSelectCheckboxes();

        },
        handleDepartmentDelete: function (index, key) {
            this.operationDepartments[index].amount = '0,00';
            this.allocatedAmounts.departments[index] = 0;
            this.operationDepartments[index].checked = false;
            let operationDepartmentIndex = this.operationDepartments.findIndex((item)=>{
                return item.id == key
            })
            this.operationDepartments.splice(operationDepartmentIndex, 1)
            this.calculateTotalAllocated();
            this.calculateLeftForSplit();
            this.handleSingleSelectCheckboxes();
        },
        clearUncheckCategories: function (index) {
            const self = this;
            let amount = '0,00';
            if (!['', undefined, null].includes(this.operationCategories)) {
                this.operationCategories.forEach((category, arrayIndex) => {
                    if (arrayIndex !== index) {
                        self.operationCategories[arrayIndex].amount = amount;
                        self.allocatedAmounts.categories[arrayIndex] = this.money.toFloat(amount);
                    }
                });
            }
            this.calculateTotalAllocated();
            this.calculateLeftForSplit();
        },
        clearSourceTransfer: function () {
            let amount = '0,00';
            this.operationSourceTransfer.amount = amount
            this.allocatedAmounts.transferBetweenSources[0] = this.money.toFloat(amount);
            this.calculateTotalAllocated();
            this.calculateLeftForSplit();
        },
        handleCategoryCheckboxChange: function (index) {
            let amount = '0,00';
            if (this.operationCategories[index].checked) {
                this.clearUncheckCategories(index);
                this.clearSourceTransfer();
                amount = this.leftForSplit;
            }

            this.operationCategories[index].amount = amount;
            this.allocatedAmounts.categories[index] = this.money.toFloat(amount);
            this.calculateTotalAllocated();
            this.calculateLeftForSplit();
            this.handleSingleSelectCheckboxes();
            this.operationCategories.forEach((category, arrayIndex) => {
                if (arrayIndex !== index) {
                    category.checked = false;
                }
            });
            this.operationSourceTransfer.checked = false;
        },
        handleCategoryExchangeRateChange: function (index) {
            this.operationCategories[index].exchange_rate = this.money.localize(this.money.toFloat(this.operationCategories[index].exchange_rate), 4, 16);
            let connected = 0;
            if (this.isOperationNonDefaultCurrencySourceDefault()) {
                connected = this.money.toFloat(this.operationCategories[index].amount) / this.money.toFloat(this.operationCategories[index].exchange_rate);
                this.operationCategories[index].exchanged_amount = this.money.localize(connected);

            } else if (!this.source.currency_is_default && this.useExchangeRates) {
                connected = this.money.toFloat(this.operationCategories[index].amount) * this.money.toFloat(this.operationCategories[index].exchange_rate);
                this.operationCategories[index].exchanged_amount = this.money.localize(connected);
            }
            this.calculateTotalAllocated();
            this.calculateLeftForSplit();
        },
        isOperationNonDefaultCurrencySourceDefault: function () {
            return !this.operation.currency_is_default && this.source.currency_is_default;
        },
        updateSourceTransferAllocation: function (amount) {
            const allocation = Allocation.fromObject({
                amount: amount,
                allocation_id: this.operationSourceTransfer.id,
                exchange_rate: "1,0000",
                currency: this.operation.currency,
                exchange_target_currency: this.operation.currency,
            });
            this.updateStateToCommit('transferBetweenSources', allocation);
        },
        updateOperationDocumentsPaymentsAllocation: function (amount) {
            const allocation = Allocation.fromObject({
                amount: amount,
                allocation_id: this.operationDocumentsPayments.id,
                exchange_rate: "1,0000",
                currency: this.operation.currency,
                exchange_target_currency: this.operation.currency,
            });
            this.updateStateToCommit('documentsPayments', allocation);
        },
        handleSourceTransferCheckboxChange: function () {
            let amount = '0,00';
            if (!['', undefined, null].includes(this.operationSourceTransfer) && this.operationSourceTransfer.checked) {
                this.clearUncheckCategories(null);
                amount = this.leftForSplit;
            }
            this.operationSourceTransfer.amount = amount;
            this.allocatedAmounts.transferBetweenSources[0] = this.money.toFloat(amount);
            this.calculateTotalAllocated();
            this.calculateLeftForSplit();
            this.handleSingleSelectCheckboxes();
            this.operationCategories.forEach(category => {
                category.checked = false;
            })
        },
        handleOperationDocumentsPaymentsCheckboxChange: function () {
            if (!this.operationDocumentsPayments.checked) {
                this.clearOperationDocumentsPayments();
            } else {
                this.operationDocumentsPayments.amount = this.leftForSplit;
                this.allocatedAmounts.documentsPayments[0] = this.money.toFloat(this.leftForSplit);
                this.calculateTotalAllocated();
                this.calculateLeftForSplit();
            }
        },
        handleOperationDocumentsPaymentsAmountChange: function () {
            this.operationDocumentsPayments.amount = this.validateSign(this.operationDocumentsPayments.amount);
            if (Math.abs(this.money.toFloat(this.operationDocumentsPayments.amount)) > Math.abs((this.money.toFloat(this.leftForSplit) + this.allocatedAmounts.documentsPayments[0]))) {
                this.operationDocumentsPayments.amount = this.money.localize(this.money.toFloat(this.leftForSplit) + this.allocatedAmounts.documentsPayments[0]);
            } else {
                this.operationDocumentsPayments.amount = this.money.localize(this.money.toFloat(this.operationDocumentsPayments.amount));
            }
            this.allocatedAmounts.documentsPayments[0] = this.money.toFloat(this.operationDocumentsPayments.amount)
            this.updateOperationDocumentsPaymentsAllocation(this.operationDocumentsPayments.amount)
            this.calculateTotalAllocated();
            this.calculateLeftForSplit();
        },
        clearOperationDocumentsPayments: function () {
            let amount = '0,00';
            this.operationDocumentsPayments.amount = amount
            this.allocatedAmounts.documentsPayments[0] = this.money.toFloat(amount);
            this.updateOperationDocumentsPaymentsAllocation(amount)
            this.calculateTotalAllocated();
            this.calculateLeftForSplit();
        },
        isDepartmentDisabled: function (department) {
            return (this.isOperationAllocatedForDepartment(department) && this.isAllocationAllocated(department)) || this.isEqualPaymentSourceDepartment(department);
        },
        isDepartmentReadonly: function (department) {
            return !this.isOperationAllocatedForDepartment(department) || this.isAllocationAllocated(department) || this.isEqualPaymentSourceDepartment(department);
        },
        isEqualPaymentSourceDepartment: function (department) {
            return this.source.department_id === department.id;
        },
        isCurrentDepartmentVisible: function (department) {
            return !this.isEqualPaymentSourceDepartment(department) || (this.isEqualPaymentSourceDepartment(department)
                && this.isOperationAllocatedForDepartment(department) && this.money.toFloat(department.amount) > 0);
        },
        prepareDepartments: function (fromDepartment = null, toDepartment= null) {
            const self = this;
            const preparedDepartments = [];
            var notDepartmentTransfer = [];
            var onlyDepartmentTransfer = [];
            if(fromDepartment == null && toDepartment == null){
                this.forceDepartment = false;
                this.departments.forEach((resource) => {
                    let state = null;
                    if(self.modalContext.departmentTransfers !== undefined && self.modalContext.departmentTransfers.length > 0){
                        state = self.modalContext.departmentTransfers.filter(state => {
                            return state.target.department_id === resource.id
                        })
                        notDepartmentTransfer = self.modalContext.departmentTransfers.filter(state => {
                            return state.target.department_id === resource.id && state.target_type !== 'App\\DepartmentTransfer'
                        })
                        onlyDepartmentTransfer = self.modalContext.departmentTransfers.filter(state => {
                            return state.target.department_id === resource.id && state.target_type === 'App\\DepartmentTransfer'
                        })
                    }
                    if ((!self.isEqualPaymentSourceDepartment(resource) || self.isOperationAllocatedForDepartment(resource)) || onlyDepartmentTransfer.length === 1) {
                        if(resource.id !== self.source.department_id ||  onlyDepartmentTransfer.length === 1){
                            preparedDepartments.push({
                                checked: isSet(state) && state.length > 0 ? true : self.isOperationAllocatedForDepartment(resource),
                                disabled: isSet(state) && state.length > 0 ? ((notDepartmentTransfer.length > 0 && (onlyDepartmentTransfer.length === 1 || onlyDepartmentTransfer.length == 0 )) || onlyDepartmentTransfer.length === 1 && notDepartmentTransfer.length === 0 && self.source.department_id === onlyDepartmentTransfer[0].target.department_id) : self.isDepartmentDisabled(resource),
                                readonly: isSet(state) && state.length > 0 ? ((notDepartmentTransfer.length > 0 && (onlyDepartmentTransfer.length === 1 || onlyDepartmentTransfer.length == 0)) || onlyDepartmentTransfer.length === 1 && notDepartmentTransfer.length === 0 && self.source.department_id === onlyDepartmentTransfer[0].target.department_id): self.isDepartmentReadonly(resource),
                                id: resource.id,
                                name: resource.name,
                                amount: isSet(state) && state.length > 0 ? self.money.localize(self.sumFromState(state, resource)) : self.money.localize(self.getFirstDepartmentAmount(resource)),
                                flow_connection: state,
                                deletable: onlyDepartmentTransfer.length === 1 && self.source.department_id === onlyDepartmentTransfer[0].target.department_id
                            })
                        }

                    }
                });
            }

            else{
                this.forceDepartment = true;
                this.departments.forEach((resource) => {
                    let state = null;
                    if(self.modalContext.departmentTransfers !== undefined && self.modalContext.departmentTransfers.length > 0){
                        state = self.modalContext.departmentTransfers.filter(state => {
                            return state.target.department_id === resource.id
                        })
                        notDepartmentTransfer = self.modalContext.departmentTransfers.filter(state => {
                            return state.target.department_id === resource.id && state.target_type !== 'App\\DepartmentTransfer'
                        })
                        onlyDepartmentTransfer = self.modalContext.departmentTransfers.filter(state => {
                            return state.target.department_id === resource.id && state.target_type === 'App\\DepartmentTransfer'
                        })
                    }
                    if (true) {
                        if(resource.id !== toDepartment)
                        {
                            preparedDepartments.push({
                                checked: isSet(state) && state.length > 0 && resource.id !== toDepartment ? true : (resource.id !== toDepartment && self.isOperationAllocatedForDepartment(resource)),
                                disabled: false,
                                readonly: true,
                                id: resource.id,
                                name: resource.name,
                                amount: isSet(state) && state.length > 0 ? self.money.localize(self.sumFromState(state, resource)) : self.money.localize(self.getFirstDepartmentAmount(resource)),
                                flow_connection: state,
                                deletable: onlyDepartmentTransfer.length === 1 && self.source.department_id === onlyDepartmentTransfer[0].target.department_id,
                                forceVisible: resource.id !== toDepartment
                            })
                        }
                        else{
                            preparedDepartments.push({
                                checked: isSet(state) && state.length > 0 && resource.id !== toDepartment ? true : (resource.id !== toDepartment && self.isOperationAllocatedForDepartment(resource)),
                                disabled: false,
                                readonly: false,
                                id: resource.id,
                                name: resource.name,
                                amount: self.money.localize(0),
                                flow_connection: state,
                                deletable: onlyDepartmentTransfer.length === 1 && self.source.department_id === onlyDepartmentTransfer[0].target.department_id,
                                forceVisible: resource.id !== toDepartment
                            })
                        }

                    }
                });
            }

            return preparedDepartments.sort((a,b) => b.deletable -a.deletable);
        },
        sumFromState: function (state, resource) {
            var sum = 0;
            const self = this;
            var isReturnedToSource = false;
            state.forEach(elem => {
                if(!isReturnedToSource){
                    if(elem.target.department_id === self.source.department_id && elem.target_type === 'App\\DepartmentTransfer'){
                        sum = parseFloat(elem.source_amount)
                        isReturnedToSource = true;
                        return sum;
                    }
                    else{
                        sum = sum + (parseFloat(elem.source_amount))
                    }
                }
            })
            return sum;
        },
        prepareCleanDepartments: function () {
            const self = this;
            const preparedDepartments = [];
            this.departments.forEach((resource, index) => {
                preparedDepartments.push({
                    checked: false,
                    disabled: false,
                    readonly: true,
                    id: resource.id,
                    name: resource.name,
                    amount: self.money.localize(0),
                })
            });
            return preparedDepartments;
        },
        prepareCategories: function (index) {
            const self = this;
            const preparedCategories = [];

            if (![null, undefined, ''].includes(this.source) && ![null, undefined, ''].includes(this.source.categories)) {
                this.source.categories.forEach((resource, index) => {
                    let state = null;
                    if(self.modalContext.categoryAllocations !== undefined && self.modalContext.categoryAllocations.length > 0){
                        state = self.modalContext.categoryAllocations.find(state => {
                            return state.target.payment_source_category_id === resource.id
                        })
                    }
                    preparedCategories.push({
                        checked: !['', undefined, null].includes(state) ? true : self.isOperationAllocatedForCategory(resource),
                        disabled: false,
                        id: resource.id,
                        name: resource.name,
                        type: resource.type,
                        amount: !['', undefined, null].includes(state) ? self.money.localize(state.target_amount) : self.money.localize(self.getFirstCategoryAmount(resource)),
                        currency: self.source.currency,
                        exchange_rate: !['', undefined, null].includes(state) ? state.exchange_rate : self.money.localize(self.getFirstCategoryExchangeRate(resource), 4, 16),
                        exchanged_amount: !['', undefined, null].includes(state) ? state.exchanged_amount : self.money.localize(self.getFirstCategoryLocalAmount(resource)),
                    })
                });
            }
            return preparedCategories;
        },
        prepareCleanCategories: function () {
            const self = this;
            const preparedCategories = [];
            if (![null, undefined, ''].includes(this.source) && ![null, undefined, ''].includes(this.source.categories)) {
                this.source.categories.forEach((resource, index) => {
                    preparedCategories.push({
                        checked: false,
                        disabled: false,
                        id: resource.id,
                        name: resource.name,
                        type: resource.type,
                        amount: self.money.localize(0),
                        currency: self.source.currency,
                        exchange_rate: self.money.localize(0, 4),
                        exchanged_amount: self.money.localize(0),
                    })
                });
            }
            return preparedCategories;
        },
        prepareContractorTransfers: function () {
            const self = this;
            const preparedTransfers = [];
            if(this.modalContext.contractorTransfers!==undefined && this.modalContext.contractorTransfers.length > 0) {

                this.getContractorTransfers().forEach(resource => {
                    preparedTransfers.push({
                        checked: self.money.toFloat(resource.target_amount) !== 0 && resource.target_type === 'App\\UnallocatedPayment',
                        disabled: false,
                        id: resource.id,
                        amount:  this.money.localize(resource.source_amount),
                        local_balance:  resource.target_amount_money,
                        contractor_id: resource.target.contractor_id,
                        currency: resource.source.currency,
                        exchange_rate: resource.exchange_rate,
                        exchanged_amount: '0,00',
                        exchange_target_currency: this.operation.currency,
                        allocation_id: resource.id,
                        operation_id: resource.source.id,
                        operation: resource.source,
                        allocation: resource,
                        target_type: resource.target_type
                    })
                });
            }

            if(this.modalContext.contractorTransfers!== undefined && (this.modalContext.contractorTransfers.length === 0 || this.modalContext.contractorTransfers.length > 0)){
                let blankContactorTransfer = {...this.blankContractorTransfer};
                blankContactorTransfer.unique = Date.now();
                preparedTransfers.push(blankContactorTransfer)
            }

            return this.modalType !== 'noContractor' ? preparedTransfers : [];
        },

        prepareTransfersDocuments: function () {
            return isSet(this.modalContext.documentsForTransfers) && isSet(this.modalContext.documentsForTransfers[this.operation.id]) ? this.modalContext.documentsForTransfers[this.operation.id] : {};
        },

        prepareCleanContractorTransfers: function () {
            let blankContactorTransfer = {...this.blankContractorTransfer};
            blankContactorTransfer.unique = Date.now();
            return this.modalType !== 'noContractor' ? [blankContactorTransfer] : [];
        },
        prepareSourceTransfer: function (index) {
            const self = this;
            let state = null
            if(self.modalContext.sourceTransfers !== undefined){
                state = self.modalContext.sourceTransfers.length > 0 ? self.modalContext.sourceTransfers[0] :null
            }

            return {
                checked: !['', undefined, null].includes(state) ? true : self.isSourceTransfers(),
                disabled: false,
                id: !['', undefined, null].includes(state) ? state.id : self.getFirstSourceTransferId(),
                amount: !['', undefined, null].includes(state) ? self.money.localize(state.target_amount) : self.money.localize(self.getFirstSourceTransferAmount()),
            };
        },
        prepareCleanSourceTransfer: function () {
            const self = this;
            return {
                checked: false,
                disabled: false,
                id: 0,
                amount: self.money.localize(0),
            };
        },
        prepareDocumentsPayments: function () {
            const self = this;
            return {
                checked: self.isDocumentsPayments(),
                disabled: false,
                id: self.getFirstDocumentsPaymentsId(),
                amount: self.money.localize(self.getFirstDocumentsPaymentsAmount()),
            };
        },
        prepareCleanDocumentsPayments: function () {
            const self = this;
            return {
                checked: false,
                disabled: false,
                id: 0,
                amount: self.money.localize(0),
            };
        },
        prepareOperationGeneratedBalance: function () {
            const self = this;
            if (isSet(self.modalContext.getGeneratedBalance)) {
                self.operationGeneratedBalance = [];
                self.modalContext.getGeneratedBalance.forEach(generatedBalance => {
                    self.operationGeneratedBalance.push({
                        id: generatedBalance.id,
                        amount: generatedBalance.target_amount,
                        description: generatedBalance.target.description,
                    });
                })
            }
        },
        loadClearModalData: function () {
            this.operationDocuments = this.getOperationDocuments();
            this.$store.commit(mutations.CLEAR_MODAL_DOCUMENTS_CHECKBOXES, {
                operationId: this.operation.id
            });
            this.clearDocumentState();
            this.operationDepartments = this.prepareCleanDepartments();
            this.operationCategories = this.prepareCleanCategories();
            this.operationContractorTransfers = this.prepareCleanContractorTransfers();
            this.operationTransfersDocuments = {};
            this.operationContractorTransfersCorrections = [];
            this.operationContractorTransfersCorrectionsOffsets = [];
            this.operationContractorTransfersCurrencyExchanges = [];
            this.operationContractorTransfersCurrencyExchangesOffsets = [];
            this.operationSourceTransfer = this.prepareCleanSourceTransfer();
            this.operationDocumentsPayments = this.prepareCleanDocumentsPayments();
            this.operationPaymentCorrections = [];
            this.operationPaymentCorrectionsOffsets = [];
            this.operationCurrencyExchanges = [];
            this.operationCurrencyExchangesOffsets = [];
            this.allocatedAmounts.documentAllocations = this.operationDocuments.map(document => 0);
            this.allocatedAmounts.departments = this.operationDepartments.map(department => 0);
            this.allocatedAmounts.categories = this.operationCategories.map(category => 0);
            this.allocatedAmounts.contractorTransfers = this.operationContractorTransfers.map(contractorTransfer => 0);
            this.allocatedAmounts.transferBetweenSources = [0];
            this.allocatedAmounts.documentsPayments = [0];
            this.allocatedAmounts.paymentCorrections = this.operationPaymentCorrections.map(correction => 0);
            this.allocatedAmounts.paymentCorrectionsOffsets = this.operationPaymentCorrectionsOffsets.map(correction => 0);
            this.allocatedAmounts.currencyExchanges = this.operationCurrencyExchanges.map(correction => 0);
            this.allocatedAmounts.currencyExchangesOffsets = this.operationCurrencyExchangesOffsets.map(correction => 0);
            this.prepareOperationGeneratedBalance();
            this.allocatedAmounts.generateBalance = [0];
            this.calculateTotalAllocated();
            this.calculateLeftForSplit();
            this.handleSingleSelectCheckboxes();
        },
        loadContractorTransferPaymentCorrectionsAmount: function (contractorTransfer) {
            const self = this;
            this.contractorTransfersAllocatedAmounts[contractorTransfer.contractor_id].contractorTransfersPaymentCorrections =
                self.getTransferPaymentCorrections(contractorTransfer).map(
                    correction => {
                        return self.money.toFloat(self.getCorrectionAmount(correction))
                    }
                )
        },
        loadContractorTransferPaymentCorrectionsOffsetsAmount: function (contractorTransfer) {
            const self = this;
            this.contractorTransfersAllocatedAmounts[contractorTransfer.contractor_id].contractorTransfersPaymentCorrectionsOffsets =
                self.getTransferPaymentCorrectionsOffsets(contractorTransfer).map(
                    function (correction) {
                        return self.money.toFloat(self.getCorrectionOffsetAmount(correction));
                    })
        },
        loadContractorTransferCurrencyExchangesAmount: function (contractorTransfer) {
            const self = this;
            this.contractorTransfersAllocatedAmounts[contractorTransfer.contractor_id].contractorTransfersCurrencyExchanges =
                self.getTransfersCurrencyExchanges(contractorTransfer).map(
                    function (correction) {
                        return self.money.toFloat(self.getCorrectionAmount(correction));
                    })
        },
        loadContractorTransferCurrencyExchangesOffsetsAmount: function (contractorTransfer) {
            const self = this;
            this.contractorTransfersAllocatedAmounts[contractorTransfer.contractor_id].contractorTransfersCurrencyExchangesOffsets =
                self.getTransfersCurrencyExchangesOffsets(contractorTransfer).map(
                    function (correction) {
                        return self.money.toFloat(self.getCorrectionOffsetAmount(correction));
                    })
        },
        loadContractorTransfersAllocatedAmounts: function () {
            this.operationContractorTransfers.forEach(contractorTransfer => {
                this.contractorTransfersAllocatedAmounts[contractorTransfer.contractor_id] = {...this.contractorTransferAllocatedAmountsStruct};
                this.contractorTransfersAllocatedAmounts[contractorTransfer.contractor_id].contractorTransfersDocuments = [];
                this.loadContractorTransferPaymentCorrectionsAmount(contractorTransfer);
                this.loadContractorTransferPaymentCorrectionsOffsetsAmount(contractorTransfer)
                this.loadContractorTransferCurrencyExchangesAmount(contractorTransfer)
                this.loadContractorTransferCurrencyExchangesOffsetsAmount(contractorTransfer)
            })
        },
        loadModalData: function (init = false) {
            this.stateToCommit.generatedBalanceForDelete = [];
            this.stateToCommit.newDocumentForOperation = []
            this.newDocumentForOperation.checked = false;
            this.handleNewDocumentForOperationChanged();
            this.operationDocuments = this.getOperationDocuments();
            this.operationProformas = this.getOperationProformas();
            this.operationDepartments = this.prepareDepartments();
            this.operationCategories = this.prepareCategories();
            this.operationContractorTransfers = this.prepareContractorTransfers();
            this.clearOperationContractorTransfers = this.fetchClearOperationContractorTransfers()
            this.operationContractorTransfersCorrections = this.getTransfersPaymentsCorrections();
            this.operationContractorTransfersCorrectionsOffsets = this.getTransfersPaymentsCorrectionsOffsets();
            this.operationContractorTransfersCurrencyExchanges = this.getTransfersCurrencyExchanges();
            this.operationContractorTransfersCurrencyExchangesOffsets = this.getTransfersCurrencyExchangesOffsets();
            this.operationTransfersDocuments = this.prepareTransfersDocuments();
            this.operationSourceTransfer = this.prepareSourceTransfer();
            this.operationDocumentsPayments = this.prepareDocumentsPayments();
            this.operationPaymentCorrections = this.getOperationPaymentCorrections();
            this.operationPaymentCorrectionsOffsets = this.getOperationPaymentCorrectionsOffsets();
            this.operationCurrencyExchanges = this.getOperationCurrencyExchanges();
            this.operationCurrencyExchangesOffsets = this.getOperationCurrencyExchangesOffsets();
            this.allocatedAmounts.documentAllocations = this.operationDocuments.map(
                document => this.money.toFloat(document.allocation.amount)
            );
            this.prepareOperationGeneratedBalance()
            this.allocatedAmounts.departments = this.operationDepartments.map(
                department => department.checked ? this.money.toFloat(department.amount) : 0
            );
            this.allocatedAmounts.categories = this.operationCategories.map(
                category => category.checked ? this.money.toFloat(category.amount) : 0
            );
            this.allocatedAmounts.contractorTransfers = this.operationContractorTransfers.map(
                contractorTransfer => this.money.toFloat(contractorTransfer.amount)
            );
            this.allocatedAmounts.transferBetweenSources = [this.operationSourceTransfer.checked ? this.money.toFloat(this.operationSourceTransfer.amount) : 0];
            this.allocatedAmounts.documentsPayments = [this.isDocumentsPayments() ? this.money.toFloat(this.getFirstDocumentsPaymentsAmount()) : 0];
            this.allocatedAmounts.paymentCorrections = this.operationPaymentCorrections.map(
                correction => this.hasPaymentCorrections() ? this.getCorrectionAmount(correction) : 0
            );
            this.allocatedAmounts.paymentCorrectionsOffsets = this.operationPaymentCorrectionsOffsets.map(
                correction => this.hasPaymentCorrectionsOffsets() ? this.money.toFloat(this.getCorrectionOffsetAmount(correction)) : 0
            );
            this.allocatedAmounts.currencyExchanges = this.operationCurrencyExchanges.map(
                correction => this.hasCurrencyExchanges() ? this.money.toFloat(this.getCorrectionAmount(correction)) : 0
            );
            this.allocatedAmounts.currencyExchangesOffsets = this.operationCurrencyExchangesOffsets.map(
                correction => this.hasCurrencyExchangesOffsets() ? this.money.toFloat(this.getCorrectionOffsetAmount(correction)) : 0
            );
            this.loadContractorTransfersAllocatedAmounts();
            let operationGeneratedBalanceSum = 0;

            for (let index = 0; index < this.operationGeneratedBalance.length; ++index) {
                this.allocatedAmounts.generateBalance[index] = this.money.toFloat(this.operationGeneratedBalance[index].amount);

            }
            if (init) {
                this.leftForSplit = this.money.localize(this.getFirstUnallocatedPaymentLocalBalance());
                this.totalAllocated = this.money.toFloat(this.operation.formatted_amount) - this.money.toFloat(this.leftForSplit);
                this.checkLeftForSplitIsZero();
            } else {
                this.calculateTotalAllocated();
                this.calculateLeftForSplit();
            }
            this.handleSingleSelectCheckboxes();
            this.updateStateToCommitAllocations();
            this.updateStateLeftForSplit();


        },

        refreshDepartmentAllocationStruct: function (){
            this.allocatedAmounts.departments = [];
            this.allocatedAmounts.departments = this.operationDepartments.map(
                department => department.checked ? this.money.toFloat(department.amount) : 0
            );
        },
        calculateTotalAllocated: function () {
            let allocatedAmountsSum = Object.values(this.allocatedAmounts).reduce((sum, collection, index, arr) => {
                return collection.length === 0 ? sum : sum + collection.reduce((subSum, amount, index, arr) => {
                    return this.money.toFloat(subSum) + this.money.toFloat(amount);
                }, 0)
            }, 0);
            this.totalAllocated = allocatedAmountsSum;
        },
        calculateTotalAllocatedForContractorTransfers: function () {
            return Object.values(this.contractorTransfersAllocatedAmounts).reduce((sum, contractorTransferAllocationsCollections) => {
                return contractorTransferAllocationsCollections.length === 0 ? sum : sum + Object.values(contractorTransferAllocationsCollections).reduce((contractorTransferSum, allocationCollection) => {
                    return allocationCollection.length === 0 ? contractorTransferSum : contractorTransferSum + allocationCollection.reduce((subSum, amount) => {
                        return subSum + amount;
                    }, 0)
                }, 0)
            }, 0);
        },
        calculateLeftForSplit: function () {
            if (['', null, undefined].includes(this.operation.formatted_amount)) {
                this.operation.formatted_amount = 0
            }
            if (this.isDepartmentTransfer) {
                this.leftForSplit = this.money.localize(this.money.toFloat(this.transferToDepartmentAmount) - this.totalAllocated)
            } else {
                this.leftForSplit = this.money.localize(this.money.toFloat(this.operation.formatted_amount) - this.totalAllocated)
            }
            this.checkLeftForSplitIsZero();
        },
        checkLeftForSplitIsZero: function () {
            if(this.modalType === 'localContractor' || this.modalType === 'globalContractor'){
                this.isFilled = true;
            }
            else{
                this.isFilled = !(this.money.toFloat(this.leftForSplit) !== 0);
            }
        },
        getLeftForSplit: function () {
            return this.leftForSplit;
        },

        updateDocumentsState: function () {
            const self = this;
            events.$emit('storeCheckboxState', {
                operationId: self.operation.id
            });
            this.operationDocuments.forEach(document => {
                document.allocation['currency'] = this.operation.currency;
                this.updateStateToCommit('documentAllocations', document.allocation);
            })
            let documentAllocationsToUpdate = this.stateToCommit.documentAllocations.map((allocation, index) => {
                return {
                    allocation: allocation,
                    checked: self.getModalCheckboxes().documents[index]
                }
            })
            if(this.dynamicContent.length > 0){
                this.$store.commit(mutations.UPDATE_DOCUMENT_ALLOCATIONS, {
                    index: this.operationIndex,
                    dataToUpdate: documentAllocationsToUpdate
                })
            }

        },
        updateProformasState: function () {
            const self = this;
            events.$emit('storeCheckboxState', {
                operationId: self.operation.id
            });
            this.operationProformas.forEach(document => {
                document.allocation['currency'] = this.operation.currency;
                this.updateStateToCommit('proformaAllocations', document.allocation);
            })
            let documentAllocationsToUpdate = this.stateToCommit.proformaAllocations.map((allocation, index) => {
                return {
                    allocation: allocation,
                    checked: self.getModalCheckboxes().documents[index]
                }
            })
            if(this.dynamicContent.length > 0){
                this.$store.commit(mutations.UPDATE_DOCUMENT_ALLOCATIONS, {
                    index: this.operationIndex,
                    dataToUpdate: documentAllocationsToUpdate
                })
            }

        },
        clearDocumentState: function () {
            const self = this;
            this.operationDocuments.forEach(document => {
                document.allocation['currency'] = this.operation.currency;
                this.updateStateToCommit('documentAllocations', document.allocation);
            })
            let documentAllocationsToUpdate = this.stateToCommit.documentAllocations.map((allocation, index) => {
                allocation['checked'] = false;
                allocation['operation_id'] = self.operation.id;
                return {
                    allocation: allocation,
                    checked: false,
                }
            })
            // this.$store.commit(mutations.UPDATE_DOCUMENT_ALLOCATIONS, {
            //     index: this.operationIndex,
            //     dataToUpdate: documentAllocationsToUpdate
            // });
        },
        updateDocumentPaymentState: function () {
            let documentPayment = Allocation.fromObject({
                amount: this.operationDocumentsPayments.amount,
                operation_id: this.operation.id,
                exchange_rate: "1,0000",
                currency: this.operation.currency,
                exchange_target_currency: this.operation.currency,
                allocation_id: this.operationDocumentsPayments.id,
                checked: this.operationDocumentsPayments.checked,
                disabled: this.operationDocumentsPayments.disabled,
            });
            this.updateStateToCommit('documentsPayments', documentPayment);
        },
        updateDepartmentsState: function () {
            this.operationDepartments.forEach(department => {
                const allocation = Allocation.fromObject({
                    amount: department.amount,
                    department_id: department.id,
                    exchanged_amount: department.amount,
                    currency: this.operation.currency,
                    exchange_target_currency: this.operation.currency,
                    checked: department.checked,
                    disabled: department.disabled,
                    readonly: department.readonly,
                    operation_id: this.operation.id,
                    allocation_id: department.id,
                });
                this.updateStateToCommit('departments', allocation);
            });
        },
        updateCategoriesState: function () {
            this.operationCategories.forEach(category => {
                const allocation = Allocation.fromObject({
                    amount: category.amount,
                    exchange_rate: category.exchange_rate,
                    exchanged_amount: category.exchanged_amount,
                    currency: this.operation.currency,
                    exchange_target_currency: this.operation.currency,
                    operation_id: this.operation.id,
                    allocation_id: category.id,
                    checked: category.checked,
                });
                this.updateStateToCommit('categories', allocation);
            });
        },
        updateSourceTransferState: function () {
            let sourceTransfer = Allocation.fromObject({
                amount: this.operationSourceTransfer.amount,
                exchanged_amount: this.operationSourceTransfer.amount,
                currency: this.operation.currency,
                exchange_target_currency: this.operation.currency,
                operation_id: this.operation.id,
                allocation_id: this.operationSourceTransfer.id,
                checked: this.operationSourceTransfer.checked,
                disabled: this.operationSourceTransfer.disabled,
            });
            this.updateStateToCommit('transferBetweenSources', sourceTransfer);
        },
        updateNewDocumentForOperation: function () {
          let newDocumentForOperation = Allocation.fromObject({
            amount: this.newDocumentForOperation.amount?? '0,00',
            document_number: this.newDocumentForOperation.document_number,
            name_of_service: this.newDocumentForOperation.name_of_service,
            exchanged_amount: this.newDocumentForOperation.amount,
            currency: this.operation.currency,
            exchange_target_currency: this.operation.currency,
            operation_id: this.operation.id,
            allocation_id: this.newDocumentForOperation.id,
            checked: this.newDocumentForOperation.checked,
            disabled: this.newDocumentForOperation.disabled,
          });
          this.updateStateToCommit('newDocumentForOperation', newDocumentForOperation);
        },
        updateContractorTransfersState: function () {
            this.operationContractorTransfers.forEach((transfer, index) => {
                const allocation = Allocation.fromObject({
                    id: transfer.id,
                    amount: transfer.amount,
                    local_balance: transfer.local_balance,
                    contractor_id: transfer.contractor_id,
                    exchanged_amount: transfer.amount,
                    currency: this.operation.currency,
                    exchange_target_currency: this.operation.currency,
                    operation_id: transfer.operation_id,
                    allocation_id: transfer.id !== 0 ? transfer.allocation_id : -1 * index,
                    checked: transfer.checked,
                    disabled: transfer.disabled,
                    readonly: transfer.readonly,
                    to_delete: transfer.to_delete,
                    operation: transfer.operation,
                    allocation: transfer.allocation
                });

                this.updateStateToCommit('contractorTransfers', allocation);
            })
        },
        updateState: function (clear) {
            if (!clear) {
                this.updateDocumentsState();
                this.updateProformasState();
            }
            this.updateDocumentPaymentState();
            this.updateDepartmentsState();
            this.updateCategoriesState();
            this.updateContractorTransfersState();
            this.updateSourceTransferState();
            this.updateNewDocumentForOperation()
        },
        sendToStore: function (clear = false) {
            this.updateState(clear);
            this.updateStateToCommitAllocations();
            this.updateStateLeftForSplit();
        },
        notifyContractorChanged: function () {
            this.$emit('contractorChanged');
        },

        saveDepartmentTransferOperation: function () {
            this.updateState(false);
            let dataToSubmit = {
                allocations: this.stateToCommit,
                left_for_split: this.money.toFloat(this.leftForSplit)
            };
            this.$store.dispatch(actions.SUBMIT_DEPARTMENT_TRANSFERS_FORM, {
                operation_id: this.operation.id,
                data_to_submit: dataToSubmit
            }).then(() => {
                window.location.reload();
            })
        },
        saveOperation: function () {
            this.sendToStore();
            if (this.modalType === 'localContractor' && (this.isAnyCategoryChecked() || this.operationSourceTransfer.checked)) {
                this.operation.contractor_id = 0;
                this.notifyContractorChanged();
            }
            // this.updateTitle();

        },
        save: function () {
            toggleLoader()
            this.saveOperation();
            if(this.operation.id < 0){
                this.stateToCommit['departments'] = this.stateToCommit['departments'].filter(department => department['checked'] === true)
            }
                const self = this;
                this.submitting = true;
                const group = this.$store.getters.getGroupData
                this.$store.dispatch(actions.SAVE_OPERATION, {
                    action_type: self.actionType,
                    operation_modal_content: self.stateToCommit,
                    created_operation:self.operation,
                    left_for_split: self.leftForSplit,
                    target_department_id:  self.transferTargetDepartment,
                    current_url_to_block:$('#current-url-to-lock').val(),
                    current_route_to_block:$('#current-route-to-lock').val(),
                }).then(response => {

                    if(response.data.notification.alert_type === 'error'){
                        self.$swal({
                            title: self.__("warning_!"),
                            text: self.__("connected_document_was_deleted"),
                            icon: "warning",
                            showCancelButton: false,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: self.__("ok"),
                            closeOnConfirm: true
                        });
                    }

                    if(response.data.notification.alert_type !== 'error'){
                        toastr[response.data.notification.alert_type](self.__(response.data.notification.message)).css('border', '0px')
                        self.hideModal();

                        if(self.actionType === 'createGroup' || self.actionType === 'editGroup' || self.actionType === 'create'|| self.actionType === 'edit'){
                            if(self.isDepartmentTransfer){
                               return window.location.href = window.location.href.split('?')[0];
                            }
                            else{
                                let modalCheckboxes = {
                                    documents: [],
                                    departments: [],
                                    categories: [],
                                    transfers: [],
                                    source: []
                                };
                                this.$store.commit(mutations.INIT_MODAL_CHECKBOXES, {
                                    'operationId': response.data.notification.created_operation,
                                    'checkboxesCollection': modalCheckboxes
                                });
                                this.$emit('reloadOperations',response.data.notification.created_operation, self.operation.id, self.operation.date, response.data.notification.operation_title, null ,response.data.notification.original_index, response.data.notification.operation_object)
                            }
                        }else{
                                return location.reload();
                        }
                    }
                    if(this.forceDepartment){
                        toggleLoader(false)
                        window.location.reload(true);
                    }
                }).catch(error => {
                    console.log('errors: ', error);
                    this.formErrors = error.response.data.errors;
                    self.errors = error.response.data.errors
                    toggleLoader(false)
                    window.localStorage.clear();
                    this.submitting = false;
                });

        },
        restoreModal: function () {
            this.hideModal();
        },
        getContractorName: function (contractorId) {
            return this.contractorsList.find(contractor => parseFloat(contractorId) === contractor.id)
        },
        addLeftForSplitTitlePart: function () {
            this.concatTitlePart(this.operation.formatted_amount, this.__('unallocated_payments'));
        },
        updateTitle: function () {
            //N083 Tytułem operacji Nieodczytanej się nie zmienia
            if (this.operation.not_recognised) {
                return;
            }
            this.$data.title = '';
            if(this.isContractorGlobal(this.operation.contractor_id)){
                this.$data.title += this.__('payments_for_documents')+': '+ this.operation.formatted_amount;
            }
            else{
                if(this.operation.contractor_id === "0" || this.operation.formatted_amount == '0,00' || this.operation.contractor_id === 0){
                    this.$data.title = '';
                }
                else{
                    this.$data.title += this.__('unallocated_payments')+': '+ this.operation.formatted_amount;
                }
            }
            this.operation.title = this.$data.title;
        },
        concatTitlePart: function (amount, paymentTypeName) {
            if (amount !== '0,00') {
                if(this.isContractorGlobal(this.operation.contractor_id)){
                    this.$data.title += __('payments_for_documents')+': '+ amount;
                }
                else{
                    this.$data.title += __('unallocated_payments')+': '+ amount;
                }

            }
        },
        isContractorGlobal: function (contractorId) {
            let contractorsFiltered = this.contractorsList.filter(contractor => contractor.id === parseFloat(contractorId))
            if (contractorsFiltered.length === 0) {
                return false;
            } else {
                return contractorsFiltered[0].is_global;
            }
        },
        contractorsWithoutOperationContractor: function (contractorsList) {
            const self = this;
            return contractorsList.filter(contractor => {
                return parseFloat(self.operation.contractor_id) !== contractor.id
            })
        },
        contractorsWithoutGlobal: function (contractorsList) {
            const self = this;
            return contractorsList.filter(contractor => {
                return !self.isContractorGlobal(contractor.id)
            })
        },
    },
    computed: {
        select2DropdownParent: function () {
            return $('#modalContent');
        },
        disabledFieldsForNewDocumentOperation(){
            return !this.newDocumentForOperation.checked
        },
        useExchangeRates: function () {
            return this.$store.getters.getUseExchangeRates;
        },
        defaultCurrency: function () {
            return this.$store.getters.getDefaultCurrency;
        },
        modalContext: function () {
            // this.$store.getters.getModalContext
            this.$store.commit(mutations.INIT_MODAL_CONTENT, {
                'content': this.dynamicContent
            });
            return this.dynamicContent;
        },
        source: function () {
            return this.operation.payment_source ?? this.$store.getters.getSource;
        },
        departments: function () {
            return this.$store.getters.getDepartments
        },
        departmentTransfers: function(){
          return this.$store.getters.getDepartmentTransfers
        },
        contractorsList: function () {
            return this.$store.getters.getSelect2ContractorsList
        },
        contractorsForTransfers: function () {
            // operationContractorTransfers[contractorTransferIndex].contractor_id
            this.contractorIds = [];
            this.operationContractorTransfers.forEach(contractor_transfer => {
                if(parseInt(contractor_transfer.contractor_id) !== 0 && contractor_transfer.checked){
                    this.contractorIds.push(parseInt(contractor_transfer.contractor_id))
                }
            });

            let contractorsList = this.contractorsWithoutOperationContractor(this.contractorsList);
            if (!this.source.currency_is_default) {
                contractorsList = this.contractorsWithoutGlobal(contractorsList);
            }

            let filter = contractorsList.filter(contractor => {
                return !this.contractorIds.includes(parseInt(contractor.id))
            });
            return  filter;
        },

        helpLocalizationName: function () {
            return this.$props.helpName;
        }
    },
    mounted() {
        const self = this;
        let departmentsCheckboxes = this.departments.map(function (department) {
            return self.isOperationAllocatedForDepartment(department);
        });
        let categoriesCheckboxes = ![null, undefined, ''].includes(this.source) && ![null, undefined, ''].includes(this.source.categories) ? this.source.categories.map(function (categories) {
            return self.isOperationAllocatedForCategory(categories);
        }) : [];
        let transfersCheckboxes = this.operationContractorTransfers.map(function (transfer) {
            return transfer.checked;
        });
        let sourceTransferCheckbox = [this.isSourceTransfers()];
        let modalCheckboxes = {
            documents: [],
            departments: departmentsCheckboxes,
            categories: categoriesCheckboxes,
            transfers: transfersCheckboxes,
            source: sourceTransferCheckbox
        };
        this.$store.commit(mutations.INIT_MODAL_CHECKBOXES, {
            'operationId': this.operation.id,
            'checkboxesCollection': modalCheckboxes
        });

        if (this.operation.id > 0) {
        } else {
            this.loadClearModalData();
        }

        if (this.isAnyDepartmentDisabled()) {
            this.$emit('departmentTransferAccepted')
        }

    },
}
</script>

<style scoped>

.tr-errors > td {
    border: 0 !important;

}

tbody > tr > td {
    border: 0 !important;
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.connect-with-content {
    font-size: 11px !important;
}

.modal-xl {
    max-width: 1200px !important;
}

thead th {
    /** fix the problem of floating headers in scrolling modal **/
    position: relative !important;
    top: inherit !important;
}

.disabledIcon {
    pointer-events: none;
}

.disabledIcon > i {
    color: #E9ECEF;
}
</style>
